{
    "apiErrors": {
        "draft_busy": "Too many replies are being drafted right now. Try again in a moment.",
        "special_hours_require_business_hours": "Special hours need business hours. Keep business hours with at least one open day, or remove the special dates first.",
        "special_hours_duplicate_date": "A special date is listed more than once. Keep one entry per date.",
        "menu_name_conflict": "Another published menu with the same name exists on one of this menu's locations. Rename one of the menus first.",
        "conversation_assigned_to_agent": "This conversation is handled by Pulse. Join the conversation to take it over.",
        "conversation_already_in_team": "The conversation is already in this team.",
        "team_not_found": "This team no longer exists. Refresh the page and try again.",
        "conversation_assigned_to_another_user": "This conversation is assigned to another agent. Join the conversation to take it over.",
        "billing_surveys_advanced_disabled": "This feature is available on the Professional plan.",
        "google_authentication_failed": "Couldn't connect integration",
        "google_access_revoked": "Couldn't connect integration",
        "google_auth_code_expired": "Google sign-in expired. Please try again",
        "google_server_error": "Google is temporarily unavailable. Please try again later",
        "something_wrong": "Something went wrong",
        "validation": "Something went wrong",
        "message_too_long": "The post text is too long for one of the selected platforms. Shorten the message and try again.",
        "duplicate_question_titles": "Question titles must be unique. Duplicates: {{duplicates}}",
        "forbid": "Unauthorized access",
        "unauthorized": "Unauthorized access",
        "google_access_revoke_error": "Couldn't disconnect integration",
        "google_validation_failed": "Google rejected this request: {{reasons}}",
        "google_not_found": "Google verification is not available for this location at the moment",
        "google_publish_reply_error": "Couldn't publish the reply for this review",
        "google_delete_reply_error": "Couldn't delete the reply for this review",
        "review_not_found": "Couldn't reply to the review because it no longer exists",
        "google_reply_rejected": "Google didn't accept the request. Please try again later",
        "review_still_live_on_google": "This review is still live on Google",
        "google_verification_unavailable": "Couldn't check with Google whether the review still exists. Please try again later",
        "google_reply_unclaimed_location": "Google doesn't accept replies for this listing until it's verified in Google Business Profile",
        "google_my_business_missing_rights": "Grant 'Manage Listings' permissions during Google sign-up to proceed",
        "delete_user_failed_assigned_to_other_companies": "Cannot delete. User is assigned to other locations",
        "user_already_exists": "User with email {{email}} exists",
        "user_not_found": "User do not exists",
        "invalid_credentials": "Invalid credentials",
        "google_email_unverified": "Verify this email address in your Google account, then try again",
        "invalid_password": "Invalid password",
        "invitation_token_invalid": "This invitation link is invalid or has expired",
        "invitation_already_accepted": "This invitation has already been accepted",
        "invitation_email_mismatch": "The Google account email doesn't match the invitation email",
        "campaign_not_enough_credits": "You don’t have enough messages to run this campaign",
        "cannot_edit_campaign": "You cannot edit campaign",
        "running_campaigns_exists": "Cannot proceed: {{amount}} active campaign(s) in progress",
        "running_coupons_exist": "Cannot proceed: {{amount}} active coupon template(s) assigned to this location",
        "active_directories_addon_exists": "Cancel this location's Local Directories add-on first",
        "location_country_locked_by_listings": "Cancel this location's Local Directories add-on or disconnect its listing before changing its country",
        "location_country_required": "Set the location's country",
        "location_country_locked_by_google": "Disconnect this location's Google listing before changing its country",
        "google_listing_country_mismatch": "This Google listing is in {{listingCountry}}, but the location is in {{locationCountry}}. Connect a listing in the location's country",
        "located_in_self_reference": "A location can't be located inside itself. Pick the business this location is inside",
        "located_in_place_required": "Pick the business this location is inside, or switch off \"Located inside another business\"",
        "tracking_tags_medium_invalid": "Use lower-case letters, digits and hyphens for utm_medium",
        "tracking_tags_medium_paid": "Analytics would count this utm_medium as paid traffic. Pick another value",
        "tracking_tags_campaign_invalid": "Use lower-case letters, digits and hyphens for utm_campaign",
        "tracking_tags_campaign_shopping": "Analytics would count this utm_campaign as shopping traffic. Pick another value",
        "store_code_too_long": "A store code has at most 64 characters",
        "located_in_place_invalid": "That business could not be recognised on Google. Search for it again and pick it from the results",
        "located_in_relation_invalid": "Pick a relationship type for the business this location is inside",
        "pulse_ai_agent_assigned": "Cannot proceed: active agent on this location",
        "campaign_empty": "There are no contacts in the selected segment",
        "campaign_audience_to_big": "Unable to create a campaign with more than 1000 contacts",
        "maximum_daily_messages_reached": "Maximum of daily messages has been reached",
        "over_survey": "Request to this contact has been sent in the past {{delay}} day(s)",
        "contact_unsubscribed": "This contact is unsubscribed",
        "ticket_managenet_disabled": "Upgrade your subscription to use this feature",
        "maximum_sms_count_reached": "Upgrade your subscription to send more SMS",
        "maximum_emails_count_reached": "Upgrade your subscription to send more emails",
        "maximum_companies_count_reached": "Upgrade your subscription to use this feature",
        "maximum_users_count_reached": "Upgrade your subscription to use this feature",
        "maximum_templates_count_reached": "Upgrade your subscription to use this feature",
        "maximum_company_services_count_reached": "Upgrade your subscription to use this feature",
        "maximum_reply_rules_count_reached": "Upgrade your subscription to use this feature",
        "review_platforms_disabled": "Upgrade your subscription to use this feature",
        "IFOOD_REVIEW_ALREADY_REPLIED": "Review has already been replied",
        "IFOOD_MERCHANT_NOT_REGISTERED": "iFood access for this merchant is not active",
        "IFOOD_INTEGRATION_NOT_CONNECTED": "iFood integration is not connected",
        "IFOOD_REVIEW_DISCARDED_OR_MODERATION_PENDING": "Review is pending moderation or discarded",
        "IFOOD_AUTHENTICATION_FAILED": "iFood Authentication failed",
        "IFOOD_INVALID_REVIEW_REPLY_LENGTH": "Comment length must be between 10 and 300 characters",
        "IFOOD_EMPTY_REVIEW": "You can't reply to review with empty comment",
        "IFOOD_REVIEW_RATING_NOT_REPLYABLE": "Five-star reviews cannot be replied to",
        "IFOOD_REVIEW_REPLY_WINDOW_EXPIRED": "iFood stops accepting replies 5 days after a review is left",
        "channel_not_connected": "You can't send messages to this channel because it isn't connected.",
        "channel_unreachable_contact": "This contact can't receive messages from this channel. Check the phone number and try again.",
        "ringcentral_not_connected": "The RingCentral account is no longer connected. Reconnect it under Integrations.",
        "ringcentral_number_not_available": "The selected number can't send SMS from this RingCentral account.",
        "ringcentral_unavailable": "RingCentral isn't responding. Try again in a few minutes.",
        "channel_phone_number_in_use": "This phone number is already used by another channel.",
        "sms_provider_cannot_change": "The provider of an existing SMS channel can't be changed. Create a new channel instead.",
        "file_size_too_large": "File size should not exceed {{size}} {{metric}}",
        "attachment_type_not_supported": "This file type can't be sent on this channel",
        "file_size_too_small": "File size should not be smaller than {{size}} {{metric}}",
        "image_dimensions_too_small": "Image must be at least {{minWidth}}×{{minHeight}} pixels",
        "video_duration_out_of_range": "Video must be between {{min}} and {{max}} seconds for the selected platforms",
        "VTEX_AUTHENTICATION_FAILED": "VTEX Authentication failed",
        "COVERMANAGER_NOT_CONNECTED": "CoverManager is not connected",
        "FACEBOOK_NOT_AUTHENTICATED": "Facebook is not authenticated",
        "FACECBOOK_COMMON_ERROR": "Facebook is not available at the moment, please try again later",
        "WHATSAPP_REGISTRATION_FAILED": "WhatsApp phone number registration failed. Please ensure the number is verified and try again.",
        "WHATSAPP_CLOUD_API_NOT_ACCEPTED": "You must accept the WhatsApp Business Cloud API Terms of Service before connecting.",
        "WHATSAPP_WABA_MISSING": "WhatsApp signup did not return a WhatsApp Business Account. Please reconnect and complete the full signup flow.",
        "WHATSAPP_NUMBER_NOT_VALID": "The WhatsApp phone number format is not valid.",
        "WHATSAPP_NUMBER_IN_USE": "This number is still registered in a WhatsApp app. If it's the WhatsApp Business app, connect again and choose to keep using the app. Otherwise back up your chats, delete that WhatsApp account, wait a few minutes, then try again.",
        "Internal error": "Something went wrong",
        "csv_validation": "Incorrect file format",
        "csv_import_phone_invalid": "Phone number must be in international format if country is not specified",
        "csv_import_country_required": "Set a country for: {{errors}}",
        "invalid_format": "Incorrect file format",
        "request_timeout": "The request timed out. Please try again",
        "channel_configuration_error": "Unable to send message: Invalid channel configuration",
        "phoneOrEmailRequired": "Either a phone or an email must be required",
        "phone_number_required": "Contact phone number is required",
        "email_required": "Contact email address is required",
        "invalid_email": "Contact email address is not valid: {{errors}}",
        "videos_not_supported_by_google": "Videos aren't supported for Google",
        "google_allow_one_image": "Google posts can only have 1 image",
        "stories_allow_one_media": "Stories allow exactly one image or video",
        "facebook_allow_one_video": "Facebook posts can only have 1 video",
        "facebook_allow_one_type_of_media": "Facebook video posts cannot include images",
        "tiktok_allow_one_video": "TikTok posts can only have 1 video",
        "tiktok_no_mixed_media": "TikTok posts cannot mix photos and videos",
        "tiktok_max_photos_exceeded": "TikTok photo posts support at most 35 images",
        "x_allow_one_video": "X posts can only have 1 video",
        "x_no_mixed_media": "X posts cannot mix photos and videos",
        "x_max_photos_exceeded": "X posts support at most 4 images",
        "linkedin_allow_one_video": "LinkedIn posts can only have 1 video",
        "linkedin_no_mixed_media": "LinkedIn posts cannot mix photos and videos",
        "linkedin_max_photos_exceeded": "LinkedIn posts support at most 20 images",
        "profile_connected_to_another_location": "This online profile is already connected to another location. Please choose a different profile or disconnect it from the current location before proceeding",
        "brand_locations_required": "Brand requires at least one location",
        "brand_requires_location": "This is the brand's only location. Assign another location to the brand first",
        "delete_brand_failed_assigned_to_channels": "Cannot delete. This brand is currently assigned to active channels",
        "delete_brand_failed_assigned_to_agent": "Cannot delete. This brand is currently assigned to active agent",
        "delete_brand_failed_assigned_to_survey_templates": "Cannot delete. This brand is linked to existing survey templates",
        "conversations_export_in_progress": "Export in progress. You’ll receive an email when your file is ready",
        "export_in_progress": "Export in progress. You’ll receive an email when your file is ready",
        "invalidWhatsAppTemplate": "Template contains unsupported variables",
        "an_unexpected_error_occurred": "An unexpected error occurred. Please try again",
        "agent_sole_knowledge_owner": "Cannot delete agent. Knowledge base content is assigned only to this agent. Reassign or remove it first.",
        "team_owns_channels": "This team owns channels. Reassign its channels to another team first.",
        "team_owns_channels_requires_messaging": "Cannot remove messaging access from a team that owns channels. Reassign its channels first.",
        "channel_team_required": "Please select a team for this channel.",
        "live_chat_notification_channel_out_of_scope": "The follow-up channel must belong to the live chat's brand, or to no location or brand.",
        "live_chat_brand_required": "Choose the brand this live chat belongs to.",
        "live_chat_phone_or_email_required": "Make the email or the phone number a required field.",
        "live_chat_follow_up_channel_required": "Pick one channel to reach visitors who left.",
        "live_chat_follow_up_channel_not_collected": "The follow-up channel needs a contact field the chat does not require. Pick another channel.",
        "live_chat_locations_out_of_brand": "Every selected location must belong to the chosen brand.",
        "live_chat_texts_required": "Write the welcome message.",
        "live_chat_welcome_name_fallback_required": "In the {{errors}} welcome message, give every [name] a fallback for visitors who are not signed in, such as [name|there].",
        "business_hours_time_zone_invalid": "The schedule's time zone is not supported. Please contact support.",
        "business_hours_invalid": "Business hours must be times like 09:00.",
        "business_hours_range_empty": "A time range can't start and end at the same time.",
        "business_hours_days_required": "Switch on at least one day.",
        "live_chat_location_out_of_scope": "This live chat does not serve the selected location.",
        "channel_team_requires_messaging": "This team has no messaging access. Choose a team with messaging permissions.",
        "page_already_connected": "This page is already connected to another channel.",
        "page_cannot_be_changed": "The page of an existing channel cannot be changed. Create a new channel instead.",
        "subscription_required": "An active subscription is required — subscribe to continue",
        "minimum_locations_required": "The Pluspoint plan starts at {{minimumLocations}} locations",
        "plan_not_available_for_new_subscriptions": "This plan is no longer available for new subscriptions",
        "custom_pricing_requires_support": "Your account has custom pricing. Contact support to change your plan or billing period.",
        "billing_catalog_ambiguous": "Billing is temporarily unavailable for this plan. Please contact support.",
        "directories_addon_requires_subscription": "Local Directories requires an active subscription",
        "directories_addon_included_in_plan": "Local Directories publishing is already included in your plan",
        "directories_addon_already_enrolled": "This location already has Local Directories",
        "directories_addon_not_enrolled": "This location does not have Local Directories",
        "directories_addon_subscription_required": "Choose which subscription to bill Local Directories to",
        "directories_addon_minimum_term": "Local Directories can be cancelled after its 3-month minimum term",
        "directories_addon_country_not_supported": "Local Directories publishing is not yet available in this location's country",
        "locations_below_directories_enrollments": "{{enrolledLocationsCount}} location(s) have Local Directories — cancel those add-ons before reducing locations",
        "billing_surveys_disabled": "Surveys are not included in your current plan",
        "billing_campaigns_disabled": "Campaigns are not included in your current plan",
        "billing_coupons_disabled": "Coupons are not included in your current plan",
        "billing_plan_not_found": "Billing plan not found",
        "billing_stripe_subscription_not_found": "Subscription not found",
        "billing_stripe_subscription_email_is_empty": "The subscription has no email on file",
        "subscription_expired": "Your subscription has expired — renew it to continue",
        "maximum_custom_domains_reached": "You've reached the maximum number of custom domains for your plan",
        "billing_listing_directories_disabled": "Listing directories are not available on your current plan",
        "email_template_name_taken": "A template with this name already exists.",
        "email_template_not_found": "Email template not found. It may have been deleted.",
        "email_template_required": "Email message campaigns require a library template.",
        "email_template_archived": "This template is archived and cannot be selected. Unarchive it in the Library first.",
        "email_template_read_only": "Starter designs are read-only. Duplicate the template to edit it.",
        "email_template_invalid_design": "The template design is invalid. Check block contents, URLs and field lengths.",
        "email_template_dynamic_link_required": "Survey and coupon campaigns need a template with a dynamic link button.",
        "email_template_dynamic_link_not_supported": "Templates with a dynamic link button can only be used in survey or coupon campaigns.",
        "email_template_link_type_mismatch": "This template's link buttons target a different destination type, so it cannot serve this campaign.",
        "email_template_links_locked_while_in_use": "This template's dynamic link buttons are used by campaigns or automations. Remove those references or duplicate the template.",
        "whatsapp_template_required": "WhatsApp campaigns require a message template.",
        "email_template_in_use": "This template is used by campaigns or automations and cannot be deleted. Remove those references first.",
        "whatsapp_template_delete_blocked": "This template is used by campaigns or automations and cannot be deleted. Remove those references or archive the template instead.",
        "whatsapp_template_in_use": "This template is used by scheduled or running campaigns or active automations. Duplicate it and edit the copy, or remove those references first.",
        "whatsapp_template_copy_code_requires_coupon": "This template's copy-code button needs a coupon campaign to supply the code.",
        "whatsapp_template_header_media_missing": "This template's image header has no image yet. Finish its setup in the Library first.",
        "whatsapp_template_not_found": "WhatsApp template not found. It may have been deleted.",
        "whatsapp_template_name_taken": "A template with this name and language already exists.",
        "whatsapp_template_invalid_content": "The template content is invalid. Check the variables, buttons and field lengths.",
        "whatsapp_template_not_editable": "This template cannot be edited in its current status.",
        "whatsapp_template_unavailable": "This WhatsApp template is currently unavailable — it may be paused, disabled or missing required settings.",
        "whatsapp_template_not_approved": "Only approved WhatsApp templates can be used in campaigns.",
        "whatsapp_template_not_mapped": "The template has unmapped variables. Finish its setup in the Library first.",
        "whatsapp_template_archived": "This template is archived and cannot be selected. Unarchive it in the Library first.",
        "whatsapp_template_waba_mismatch": "This template belongs to a different WhatsApp Business account than the selected channel.",
        "whatsapp_template_disconnected": "The WhatsApp Business account for this template is disconnected.",
        "whatsapp_template_link_required": "Survey and coupon campaigns need a template with a dynamic link button.",
        "whatsapp_template_link_not_supported": "This template has a dynamic link button, so it can only be used by survey or coupon campaigns.",
        "whatsapp_template_link_type_mismatch": "This template's link button targets a different destination type than this send needs.",
        "whatsapp_template_links_locked_while_in_use": "This template's dynamic link buttons are used by campaigns or automations. Remove those references or duplicate the template.",
        "automation_invalid_trigger": "An automation needs exactly one trigger.",
        "automation_trigger_no_events": "Pick at least one trigger event.",
        "automation_no_action": "Add at least one message or survey the trigger leads to.",
        "automation_wait_invalid": "A wait step needs a duration greater than zero.",
        "automation_survey_missing": "Choose a survey template for the survey step.",
        "automation_message_empty": "Add content to the message step.",
        "automation_condition_incomplete": "A filter is missing a field or value.",
        "automation_too_large": "An automation cannot have more than 100 steps.",
        "automation_unreachable_node": "Every step must be connected to the trigger.",
        "automation_has_cycle": "An automation can't contain loops.",
        "automation_invalid_edge": "A connection points to a missing step.",
        "automation_branch_edge_invalid": "Branch paths must be labelled yes or no.",
        "automation_branch_duplicate": "A branch can have at most one yes and one no path.",
        "automation_multiple_next": "A step can have at most one next step.",
        "automation_unexpected_branch_key": "Only branches can have labelled paths.",
        "automation_invalid_node_id": "An automation step is missing an id.",
        "automation_duplicate_node_id": "Automation steps must have unique ids.",
        "automation_node_channel_required": "Choose a channel for each message and survey step.",
        "automation_node_channel_invalid": "A step uses an invalid or not ready channel.",
        "automation_node_survey_invalid": "A step uses an invalid survey template.",
        "automation_node_coupon_invalid": "A step uses an invalid coupon template.",
        "automation_channel_type_unsupported": "This channel type isn't supported in automations.",
        "automation_segment_in_use": "This segment is used by an automation. Remove it from the automation before deleting.",
        "facebook_profile_id_missing": "This Facebook link is missing its profile id. Copy the full address from the page, including the ?id= part",
        "google_place_id_missing": "This Google link does not contain a place id",
        "profile_url_invalid": "Enter a full web address starting with http:// or https://",
        "social_platform_managed_as_link": "This social platform is managed through the location's social links, not as a review profile",
        "ubereats_store_url_invalid": "Enter an Uber Eats store page address, for example https://www.ubereats.com/store/name/id",
        "bbb_profile_url_invalid": "Enter a BBB business profile address, for example https://www.bbb.org/us/tx/san-antonio/profile/category/name-0825-1000132336",
        "thefork_restaurant_url_invalid": "Enter a TheFork restaurant page address, for example https://www.thefork.com/restaurant/name-r123",
        "booking_profile_url_invalid": "Enter a Booking.com hotel page address, for example https://www.booking.com/hotel/us/name.html",
        "expedia_group_profile_already_connected": "This location already has Expedia / Hotels.com. To switch to the other site, remove it and add the new address.",
        "expedia_group_profile_url_invalid": "Enter an Expedia or Hotels.com property page address, for example https://www.hotels.com/ho123456",
        "booking_extranet_url_invalid": "Enter a Booking.com Extranet link for this property, or its numeric property ID.",
        "media_dimensions_too_large": "Media must be no larger than {{maxWidth}}×{{maxHeight}} pixels for the selected platforms",
        "video_invalid": "This file is not a valid video",
        "video_too_long": "Video is longer than the maximum length for the selected platforms",
        "video_too_short": "Video is shorter than the minimum length of 3 seconds",
        "video_too_large": "Video is larger than the maximum upload size",
        "video_too_small": "Video file is empty or too small to be a valid video",
        "video_format_unsupported": "Only MP4 video files are supported",
        "video_processing_failed": "The video could not be processed. Try re-exporting it as MP4.",
        "video_codec_unsupported": "Video must be encoded as H.264 or HEVC — re-export it as a standard MP4",
        "video_audio_unsupported": "Video audio must be AAC — re-export it as a standard MP4",
        "video_too_large_for_platform": "This video is too large for one of the selected platforms — see the media warnings above",
        "video_too_small_for_platform": "This video is below the minimum size for one of the selected platforms",
        "video_too_long_for_platform": "This video is too long for one of the selected platforms — see the media warnings above",
        "video_too_short_for_platform": "This video is shorter than the 3 second minimum",
        "video_too_wide_for_platform": "This video's resolution is too high for one of the selected platforms — see the media warnings above",
        "video_not_supported_by_platform": "One of the selected platforms does not support video posts",
        "video_link_untrusted": "This video must be uploaded through Pluspoint before it can be used",
        "video_external_not_supported_by_tiktok": "TikTok can only publish videos uploaded through Pluspoint — upload the file or remove TikTok",
        "tiktok_settings_required": "TikTok settings are missing. Open the post and choose them.",
        "tiktok_disclosure_incomplete": "You need to indicate if your content promotes yourself, a third party, or both.",
        "video_too_long_for_creator": "The video is longer than the connected TikTok account allows.",
        "tiktok_privacy_unavailable": "The privacy option you chose is no longer available on the connected TikTok account. Retry once the account offers it again, or schedule a new post with a different audience.",
        "tiktok_branded_private": "Branded content can't be posted as Only me.",
        "tiktok_cannot_post_now": "TikTok isn't accepting posts from this account right now. Try again later.",
        "tiktok_unaudited": "Pluspoint's TikTok app is not yet approved for public posts.",
        "tiktok_account_not_resolved": "This location doesn't say which TikTok account posts for it. Choose one on the location's profile.",
        "tiktok_auth_removed": "The TikTok account was disconnected. Reconnect it, then try again.",
        "tiktok_media_pull_failed": "TikTok couldn't download the media. Try again.",
        "tiktok_media_rejected": "TikTok rejected the media. Check the format, resolution and length, then schedule a new post.",
        "tiktok_publish_cancelled": "The post was cancelled in TikTok.",
        "video_too_wide": "This video's resolution is higher than any supported platform accepts (max 4096 px on the longest side)",
        "review_reply_draft_unusable": "Pulse AI returned a draft with unfilled placeholders. Try Write reply again.",
        "recovery_form_unresolved": "The recovery form isn't available for this review. Remove its placeholder from your reply.",
        "description_contains_url": "Links are not allowed in business descriptions.",
        "special_hours_times_required": "An open special date needs its opening times.",
        "special_hours_times_not_allowed": "A closed special date can't have opening times.",
        "special_hours_invalid_time_range": "A time range must end after it starts.",
        "location_not_found": "This location no longer exists.",
        "concurrency_conflict": "Someone else changed or deleted this location at the same time. Reopen it and try again.",
        "bulk_update_conflict": "Someone else changed one of these locations while the edit was being applied. Nothing was saved. Apply the edit again.",
        "email_domain_taken": "This domain is already registered. Contact support if it is yours.",
        "email_domain_suspended": "Sending from this domain is suspended. Contact support.",
        "email_domain_public": "This is a public mailbox provider. Use a domain your business owns.",
        "email_domain_reserved": "Pluspoint domains cannot be connected.",
        "email_domain_invalid": "Enter a valid domain, for example acme.com.",
        "email_domain_return_path_invalid": "The Return-Path subdomain may contain letters, digits and hyphens only.",
        "hosted_email_capacity": "Email on your own domain cannot be connected right now. Contact support.",
        "email_domain_return_path_fixed": "This domain already has a Return-Path subdomain. Turn off the custom subdomain to reuse it.",
        "email_address_invalid": "Enter a valid email address on your own domain.",
        "email_channel_address_locked": "The address of this email channel cannot be changed.",
        "email_channel_hosted_create": "Email channels on your own domain are created through the domain setup.",
        "email_domain_in_use": "Delete the channels on this domain first.",
        "hosted_email_unavailable": "Email on your own domain is not available in this environment.",
        "channel_not_ready": "This channel is still waiting for its domain to be verified.",
        "channel_throttled": "The sending service is busy. Try again in a minute.",
        "email_domain_check_failed": "The records could not be checked right now. Try again in a minute.",
        "invalid_website": "Enter a domain, with or without a path, such as help.example.com or example.com/help",
        "document_too_many_pages": "The file should not exceed {{pages}} pages",
        "document_too_many_rows": "Each sheet should not exceed {{rows}} rows",
        "knowledge_base_document_limit": "These agents already have the maximum number of documents: {{errors}}",
        "knowledge_base_website_limit": "These agents already have the maximum number of websites: {{errors}}",
        "knowledge_base_conflict": "Someone else changed this content at the same time. Nothing was saved. Try again.",
        "file_required": "Select a file",
        "no_active_account": "You no longer have access to a Pluspoint account. Ask the account owner to invite you again.",
        "invalid_sex": "Sex must be Female or Male: {{errors}}",
        "invalid_date_of_birth": "Date of birth must be YYYY-MM-DD, or MM-DD without the year, from 1900 onwards and not in the future: {{errors}}",
        "invalid_language": "Language must be a language code such as en or pt: {{errors}}",
        "birth_year_required": "A date of birth entered by hand needs the year",
        "automation_trigger_date_invalid": "Pick a valid date and time for the trigger.",
        "automation_condition_invalid": "A filter has a value it cannot use.",
        "automation_trigger_date_passed": "This one-time date has already passed.",
        "automation_condition_event_on_date": "Event filters don't apply to an automation that starts on a date."
    },
    "AnalyticsConversion": {
        "conversion": "Conversion",
        "sentSurveys": "Sent surveys",
        "responsesReceived": "Responses received",
        "reviewsReceived": "Reviews received",
        "openedSurveys": "Opened surveys",
        "responses": "Responses",
        "proceededToReviewSite": "Proceeded to review sites",
        "responseRate": "Response rate",
        "reviewRate": "Review rate",
        "reviewRateTooltip": "Review rate includes all reviews for selected locations, not just those originating from surveys. Actual survey-driven review rate may differ.",
        "fromPreviousPeriod": "from previous period",
        "reviewsLifecycle": "Conversion Funnel",
        "overall": "Overall",
        "surveyInvitations": "Survey invitations",
        "qrCodes": "QR codes",
        "conversionTrend": "Conversion Trend"
    },
    "AnalyticsKeywords": {
        "tableTitle": "Keyword analysis table",
        "keyword": "Keyword",
        "avgRating": "Avg. rating",
        "numberOfReviews": "Number of reviews",
        "sentiment": "Sentiment",
        "positiveKeywords": "Top positive keywords",
        "negativeKeywords": "Top negative keywords"
    },
    "AnalyticsOperationalInsights": {
        "topStrengths": "Top Strengths",
        "topStrengthsSubtitle": "The categories where customers most often leave 5-star reviews.",
        "topIssues": "Top Issues",
        "topIssuesSubtitle": "The categories most frequently mentioned in lower-rated reviews.",
        "incidents": "Incidents",
        "incidentsSubtitle": "The percentage of reviews in each category that are negative. Higher values indicate a higher concentration of customer dissatisfaction.",
        "sentimentScore": "Sentiment Score",
        "sentimentScoreSubtitle": "The overall balance between positive and negative feedback for each category. Positive scores indicate strengths; negative scores indicate problem areas."
    },
    "AnalyticsReviews": {
        "averageRating": "Average rating",
        "reviews": "Reviews",
        "totalReviews": "Total reviews",
        "totalRepliesPercentage": "Reply rate",
        "totalResponses": "Total responses",
        "reviewsRatingDistribution": "Reviews rating distribution",
        "responsesRatingDistribution": "Responses rating distribution",
        "stars1": "1 star",
        "stars2": "2 stars",
        "stars3": "3 stars",
        "stars4": "4 stars",
        "stars5": "5 stars",
        "ratingsTimeline": "Ratings timeline",
        "ratingsTimelineTooltip": "Ratings timeline shows estimated historical values. Actual platform ratings may differ.",
        "reviewIndex": "Review index",
        "reviewIndexTooltip": "A score out of 100 of how customers rate your locations across their review sites, with recent reviews counting more. It appears once there are enough recent rated reviews.",
        "sentimentTrend": "Sentiment trend",
        "positiveReviews": "Positive reviews",
        "positiveResponses": "Positive responses",
        "negativeReviews": "Negative reviews",
        "negativeResponses": "Negative responses",
        "reviewSitesTrend": "Review sites trend",
        "fromPreviousPeriod": "from previous period",
        "others": "Others",
        "nps": "Net Promoter Score",
        "reviewsByDay": "Reviews by day",
        "reviewsByDaypart": "Reviews by daypart",
        "sunday": "Sun",
        "monday": "Mon",
        "tuesday": "Tue",
        "wednesday": "Wed",
        "thursday": "Thu",
        "friday": "Fri",
        "saturday": "Sat",
        "morning": "Morning",
        "afternoon": "Afternoon",
        "evening": "Evening"
    },
    "AnalyticsConversations": {
        "responseRate": "Response rate",
        "responseTime": "Response time (hours)",
        "resolutionTime": "Resolution time (hours)",
        "resolutionRate": "Resolution rate",
        "newConversations": "New conversations",
        "resolvedConversations": "Resolved conversations",
        "openConversations": "Open conversations",
        "unassignedConversations": "Unassigned conversations",
        "conversationsTrend": "Conversations trend",
        "channelsBreakdown": "Channels breakdown",
        "totalConversations": "Total conversations",
        "messagesPerConversation": "Messages per conversation",
        "conversationsHandled": "Conversations handled",
        "averageHandleTime": "Average handle time (hours)"
    },
    "AnalyticsSocialPosts": {
        "posts": "Posts",
        "followers": "Followers",
        "reach28": "28-day reach",
        "rateByReach": "Engagement rate by reach",
        "rateByFollowers": "Engagement rate by followers",
        "reach": "Reach",
        "likes": "Likes",
        "comments": "Comments",
        "shares": "Shares",
        "engagements": "Engagements",
        "clicks": "Clicks",
        "saves": "Saves",
        "percentagePoints": "{{value}} pp"
    },
    "AnalyticsPresence": {
        "searchAppearances": "Search appearances",
        "views": "Views",
        "calls": "Calls",
        "directions": "Directions",
        "websiteClicks": "Website clicks",
        "devicesBreakdown": "Devices breakdown",
        "googleSearchMobile": "Google Search – Mobile",
        "googleMapsMobile": "Google Maps – Mobile",
        "googleSearchDesktop": "Google Search – Desktop",
        "googleMapsDesktop": "Google Maps – Desktop",
        "searchKeywords": "Search keywords",
        "totalViews": "Total views"
    },
    "AnalyticsVisibility": {
        "pageTitle": "Track your visibility in local search",
        "pageSubtitle": "See how each location ranks in Google Maps results across a grid of points around it. Compare locations, track rank changes over time, run scans on demand, and open a location to see its point-by-point map and competitors.",
        "reportTitle": "Visibility report",
        "vs90DaysAgo": "vs 90 days ago",
        "loadError": "Couldn't load visibility data. Please try again.",
        "averageVisibility": "Average visibility",
        "locationsInTop3": "Locations in local top 3",
        "averageMapRank": "Average map rank",
        "location": "Location",
        "visibility": "Visibility",
        "avgRank": "Avg rank",
        "rankTrend": "Rank trend",
        "rankTrendHint": "Average map rank per month over the last 12 months, oldest to newest. Months without a scan appear as gaps.",
        "delta90d": "Rank change (90d)",
        "delta90dHint": "How the average map rank moved vs the scan closest to 90 days ago. Green — climbed closer to #1, red — dropped.",
        "inTop3": "In top 3",
        "inTop3Hint": "Share of scanned grid points where this business appeared in the local top 3 in the latest scan.",
        "avgMapRank": "Avg map rank",
        "top3Points": "Top-3 points",
        "trackedKeywords": "Tracked keywords",
        "whoWinsHere": "Who wins here",
        "business": "Business",
        "rating": "Rating",
        "you": "you",
        "runNewScan": "Run new scan",
        "printReport": "Print report",
        "scanInProgress": "Scan in progress",
        "scanDate": "Scan date",
        "googleProfile": "Google profile",
        "address": "Address",
        "phone": "Phone",
        "website": "Website",
        "mapRankTitle": "Map rank — {{keyword}}",
        "gridSpacing": "{{km}} km spacing",
        "top3": "Top 3",
        "fourToTen": "4–10",
        "elevenToTwenty": "11–20",
        "notInTop20": "Not in top 20",
        "noDataYet": "No scan results yet — set up tracking on a location to run its first scan",
        "noCoordinates": "Complete the address to enable scanning",
        "rescanConflict": "A scan is already in progress for this location",
        "gridSettings": "Grid settings",
        "gridSizeLabel": "Grid size",
        "gridSpacingLabel": "Grid spacing",
        "spacingKm": "{{km}} km",
        "addKeywordLabel": "Add keyword",
        "keywordsRequired": "Add at least one keyword",
        "excludePinsHint": "Click a pin to exclude it from tracking; click an excluded pin to restore it.",
        "keepOnePin": "At least one pin must remain tracked",
        "settingsApplyNote": "Changes take effect from the next scan.",
        "settingsSaved": "Visibility settings saved",
        "settingsSavedScanStarted": "Settings saved — first scan started",
        "autoScan": "Monthly scan",
        "autoScanHint": "When on, this location is automatically rescanned every month.",
        "autoScanConfigureFirst": "Set up tracking on this location first",
        "viewReports": "View reports",
        "runScan": "Run scan",
        "scanStarted": "Scan started",
        "configure": "Configure",
        "reviews": "Reviews",
        "reviewsHint": "Total Google reviews; the value in parentheses is the monthly change, estimated from the change in review count between the last two scans.",
        "categories": "Categories",
        "googleMapsLink": "Profile",
        "openOnGoogleMaps": "Open on Google Maps",
        "competitorPinHint": "★ — this competitor’s location"
    },
    "alertMessages": {
        "popupBlocked": "Allow pop-ups to open Google's report form",
        "createSuccess": "Successfully created",
        "createFail": "Couldn't create",
        "editSuccess": "Successfully edited",
        "editFail": "Couldn't edit",
        "deleteSuccess": "Successfully deleted",
        "deleteFail": "Couldn't delete",
        "updateSuccess": "Successfully updated",
        "updateFail": "Couldn't update",
        "retrySuccess": "Retry scheduled",
        "retryFail": "Couldn't schedule retry",
        "downloadFail": "Couldn't download",
        "printFail": "Couldn't print",
        "sendSuccess": "Successfully sent",
        "conversationCreated": "Conversation created",
        "sendFail": "Couldn't send",
        "importSuccess": "Successfully imported",
        "importFail": "Couldn't import",
        "importPartial": "Imported {{imported}} locations, skipped {{skipped}}",
        "cancelSuccess": "Successfully canceled",
        "cancelFail": "Couldn’t cancel",
        "uploadSuccess": "Successfully uploaded",
        "uploadFail": "Couldn't upload",
        "connectIntegrationSuccess": "Integration has been successfully connected",
        "connectIntegrationFail": "Couldn't connect integration",
        "ifoodConnectRequestSent": "Your iFood connection request has been sent. The integration will be activated once iFood grants access",
        "disconnectIntegrationSuccess": "Integration has been disconnected",
        "disconnectIntegrationFail": "Couldn't disconnect integration",
        "tooManyFiles": "You can upload maximum {{limit}} files",
        "loadFail": "Couldn't load"
    },
    "buttons": {
        "moveConversation": "Move conversation",
        "cancel": "Cancel",
        "close": "Close",
        "discard": "Discard",
        "clearFilters": "Clear filters",
        "copy": "Copy",
        "open": "Open",
        "delete": "Delete",
        "edit": "Edit",
        "create": "Create",
        "revoke": "Revoke",
        "save": "Save",
        "saveChanges": "Save changes",
        "merge": "Merge",
        "mergeContacts": "Merge contacts",
        "filters": "Filters",
        "applyFilters": "Apply filters",
        "addLocation": "Add location",
        "addLocationManually": "Add location manually",
        "sendMessage": "Send message",
        "reopen": "Re-open",
        "resolve": "Resolve",
        "enable": "Enable",
        "pause": "Pause",
        "continue": "Continue",
        "back": "Back",
        "done": "Done",
        "cheduleCampaign": "Schedule campaign",
        "getCode": "Get code",
        "reply": "Reply",
        "publish": "Publish",
        "connect": "Connect",
        "disable": "Disable",
        "disconnect": "Disconnect",
        "reconnect": "Reconnect",
        "sendSurveys": "Send surveys",
        "replaceCSV": "Replace CSV file",
        "uploadCSVFile": "Upload CSV file",
        "addChannel": "Add new channel",
        "importFromGoogle": "Import from Google",
        "upgradePlan": "Upgrade plan",
        "managePlan": "Manage plan",
        "changePlan": "Change plan",
        "talkToSales": "Talk to sales",
        "addUser": "Add user",
        "addRule": "Add new auto-reply",
        "createCampaign": "Create campaign",
        "import": "Import",
        "contact": "CONTACT SUPPORT",
        "setUpSurveys": "Set-up surveys",
        "viewResponses": "View survey responses",
        "newTicket": "New ticket",
        "viewTicket": "View ticket",
        "sendLink": "Send link",
        "manageMicrosites": "Manage micro-sites",
        "seeSurveyResponse": "See survey responses",
        "resolveComplaints": "Resolve complaints",
        "replyToReviews": "Reply to reviews",
        "download": "Download",
        "print": "Print",
        "viewReviews": "View reviews",
        "logIn": " Log In",
        "createNewMicrosite": "Create new microsite",
        "replace": "Replace",
        "upload": "Upload",
        "add": "Add",
        "localization": "Localization",
        "addLanguage": "Add language",
        "addCategory": "Add category",
        "addManually": "Add manually",
        "connectAnotherAccount": "Connect another account",
        "complete": "Complete",
        "addTemplate": "Add new reply template",
        "changePassword": "Change password",
        "signupButton": "Create account",
        "addSurvey": "Create new survey",
        "createQrCode": "Create QR code",
        "copyCode": "Copy code",
        "replaceSecret": "Replace secret",
        "generateSecret": "Generate secret",
        "copyLink": "Copy link",
        "preview": "Preview",
        "exportAsCSV": "Export as CSV",
        "exportAsExcel": "Export as Excel",
        "logout": "Log out",
        "deleteSite": "Delete microsite",
        "configure": "Configure",
        "documentation": "Documentation",
        "viewMore": "View more",
        "confirm": "Confirm",
        "createNewPost": "Create new post",
        "manage": "Manage",
        "connectProfile": "Connect Profile",
        "viewStatus": "View Status",
        "createNewProfile": "Create New Profile",
        "manageProfile": "Manage Profile",
        "publishProfile": "Publish Profile",
        "schedulePost": "Schedule post",
        "updateLocations": "Update locations",
        "validate": "Validate",
        "bulkUpdateCSV": "Import (CSV)",
        "bulkEdit": "Bulk edit",
        "selectAll": "Select all",
        "deselectAll": "Deselect all",
        "send": "Send",
        "addNewTemplate": "Add new template",
        "export": "Export",
        "startSync": "Start sync",
        "syncing": "Syncing..",
        "importing": "Importing..",
        "addNewDate": "Add new date",
        "report": "Report",
        "undoReport": "Undo report",
        "viewOnGoogle": "View on Google",
        "connectWithMeta": "Connect Meta Business",
        "saveDraft": "Save draft",
        "hideAllNotifications": "Hide all notifications",
        "hide": "Hide",
        "markAsReplied": "Mark as replied",
        "copyAndOpen": "Copy and open",
        "addContent": "Add content",
        "createBrand": "Create new brand",
        "addAgent": "Add agent",
        "reset": "Reset",
        "joinConversation": "Join conversation",
        "join": "Join",
        "tryForFree": "Try for free",
        "resend": "Resend code",
        "cropImage": "Confirm image",
        "assignAgents": "Assign agents",
        "upgrade": "Upgrade"
    },
    "AutomationsPage": {
        "create": "Create automation",
        "editor": {
            "channel": "Channel",
            "oncePerContact": "Once per contact",
            "save": "Save",
            "nameRequired": "Please name the automation",
            "saved": "Automation saved",
            "addStep": "Add step",
            "branchYes": "Yes",
            "branchNo": "No",
            "namePlaceholder": "Untitled automation",
            "fixIssues": "Some steps have issues. Fix the highlighted steps before saving."
        },
        "palette": {
            "send": "Send",
            "flow": "Flow"
        },
        "paletteHint": {
            "sendMessage": "Send an SMS, WhatsApp or email",
            "sendCoupon": "Send a coupon to the contact",
            "sendSurvey": "Send a survey to the contact",
            "wait": "Pause before the next step",
            "branch": "Split the path on a condition"
        },
        "trigger": {
            "whoCanEnter": "Who can enter",
            "byEvent": "Event",
            "byDate": "Date",
            "date": "Date",
            "contactBirthday": "Contact's birthday",
            "fixedDate": "A fixed date",
            "month": "Month",
            "day": "Day",
            "year": "Year",
            "everyYear": "Every year",
            "timing": "When",
            "onTheDay": "On the day",
            "before": "Before",
            "offsetDaysBefore": "Days before",
            "after": "After",
            "offsetDaysAfter": "Days after",
            "sendAt": "Time",
            "birthday": "Birthday",
            "whichSegments": "Segments (leave empty for any)",
            "daysBefore_one": "{{count}} day before",
            "daysBefore_other": "{{count}} days before",
            "daysAfter_one": "{{count}} day after",
            "daysAfter_other": "{{count}} days after"
        },
        "nodes": {
            "trigger": "Trigger",
            "branch": "If / then",
            "sendMessage": "Send message",
            "sendCoupon": "Send coupon",
            "sendSurvey": "Send survey",
            "wait": "Wait",
            "exit": "Exit",
            "setDuration": "Set duration",
            "noMessage": "No message yet",
            "pickSurvey": "Pick a survey",
            "surveySelected": "Survey selected",
            "pickCoupon": "Pick a coupon",
            "couponSelected": "Coupon selected",
            "setCondition": "Set condition",
            "pickEvents": "Pick events",
            "eventCount": "{{count}} event(s)",
            "conditionCount": "{{count}} condition(s)",
            "exitSubtitle": "Contacts leave the automation here"
        },
        "drawer": {
            "customEventType": "Custom event type (optional)",
            "branchHint": "Take the “yes” path when these conditions are met",
            "wait": "Wait"
        },
        "table": {
            "steps": "Steps",
            "enrolled": "Enrolled contacts",
            "enrolledHint": "Contacts that entered this automation",
            "failedFixHint": "This automation failed. Open it and fix the issue to turn it back on."
        },
        "conditions": {
            "everyoneEnters": "Everyone who triggers this automation will enter.",
            "matchAllHint": "Only contacts who match all of these:",
            "matchAnyHint": "Contacts who match any of these scenarios:",
            "addFilter": "Add filter",
            "addAlternative": "Add “OR” alternative",
            "scenario": "Scenario {{number}}",
            "and": "and",
            "or": "or",
            "segment": "Segment",
            "segments": "Segments",
            "eventField": "Event field",
            "jsonPathPlaceholder": "JSON path e.g. order.total",
            "value": "Value",
            "valuePlaceholder": "value",
            "operators": {
                "isAnyOf": "is any of",
                "isNoneOf": "is none of",
                "is": "is",
                "isNot": "is not",
                "isOneOf": "is one of",
                "contains": "contains",
                "notContains": "does not contain",
                "isKnown": "is known",
                "isUnknown": "is unknown",
                "greaterThan": "is greater than",
                "lessThan": "is less than"
            },
            "listPlaceholder": "values, comma-separated",
            "tooComplex": "These filters were built with an older editor and are too complex to display. Clear them to rebuild.",
            "clearFilters": "Clear filters",
            "deletedSegment": "(deleted segment)",
            "incompleteFilter": "Complete this filter or remove it",
            "eventFields": {
                "provider": "Payment provider",
                "account": "Payment account",
                "location": "Location",
                "amount": "Amount paid",
                "currency": "Currency",
                "firstPurchase": "First purchase",
                "paymentCount": "Number of purchases",
                "brand": "Brand"
            },
            "unavailableOption": "(no longer available)",
            "age": "Age",
            "contactLocation": "Contact location"
        },
        "triggers": {
            "contactCreated": "Contact created",
            "surveyResponded": "Survey responded",
            "surveySent": "Survey sent",
            "conversationResolved": "Conversation resolved",
            "reviewLeft": "Review left",
            "integrationEvent": "Integration event",
            "customEvent": "Custom event",
            "couponRedeemed": "Coupon redeemed",
            "formSubmitted": "Form submitted",
            "integrationCoverManager": "CoverManager reservation",
            "integrationVtex": "VTEX order",
            "paymentCompleted": "Payment completed",
            "bookingStarted": "Booking started",
            "bookingEnded": "Booking ended",
            "addedToSegment": "Added to a segment"
        },
        "units": {
            "minutes": "minutes",
            "hours": "hours",
            "days": "days"
        },
        "issues": {
            "triggerEvents": "Select at least one trigger event",
            "channelRequired": "Select a channel",
            "channelUnavailable": "The selected channel is disconnected or unavailable",
            "messageRequired": "Add a message",
            "emailTemplateRequired": "Select an email template",
            "whatsAppTemplateRequired": "Select a WhatsApp template",
            "surveyRequired": "Select a survey",
            "couponRequired": "Select a coupon",
            "waitInvalid": "Set a wait duration",
            "conditionIncomplete": "Complete or remove the incomplete filters",
            "segmentMissing": "A filter uses a segment that no longer exists",
            "noAction": "Add a message or survey step the trigger leads to",
            "triggerDate": "Pick the date this automation starts on",
            "eventFieldOnDate": "Remove the event filters: an automation that starts on a date has no event to filter on",
            "triggerSegmentMissing": "The trigger uses a segment that no longer exists"
        }
    },
    "CampaignsPage": {
        "title": "Manage your campaigns",
        "subtitle": "Inform your customers about important news or promotions with outbound campaigns",
        "audience": "Segment",
        "audienceHint": "Leave empty to reach all contacts.",
        "name": "Title",
        "createTitle": "Create campaign",
        "editTitle": "Edit campaign",
        "viewTitle": "Campaign details",
        "contactsNumber": "Selected contacts: {{count}}",
        "triggerEvent": "Trigger event(s)",
        "triggerExplanation": "Choose the event(s) that will initiate your messaging campaign. If you select multiple events, the campaign will be triggered whenever any of the selected events occur. In cases where multiple events take place, the delay will be counted from the latest event.",
        "surveySent": "Survey sent",
        "status0": "Scheduled",
        "status1": "In progress",
        "status2": "Completed",
        "status3": "Canceled",
        "status5": "Paused",
        "warningMessage": "To minimize the risk of being blocked by WhatsApp, it is recommended to keep the size of your marketing campaign under 50 contacts.",
        "addCoverPhoto": "Add cover photo",
        "coverPhotoFormat": "Format: JPG or PNG. Minimum width: 600 px",
        "imageFormat": "Format: JPG or PNG.",
        "addCTAButton": "Add CTA button",
        "buttonTitle": "Button title",
        "addImage": "Add image"
    },
    "common": {
        "unsavedChangesTitle": "Discard unsaved changes?",
        "unsavedChangesDescription": "You have unsaved changes that will be lost if you close this window.",
        "enabled": "Enabled",
        "unknown": "Unknown user",
        "noOptions": "No options",
        "noData": "No data",
        "noNotifications": "There are no new notifications",
        "timeframe": "Timeframe",
        "allTime": "All time",
        "today": "Today",
        "previous": "Previous",
        "next": "Next",
        "last7Days": "Last 7 days",
        "lastWeek": "Last week",
        "last30Days": "Last 30 days",
        "last90Days": "Last 90 days",
        "thisMonth": "This month",
        "lastMonth": "Last month",
        "thisYear": "This year",
        "exportError": "Couldn't export data as CSV",
        "zapierIntegration": "Zapier integration",
        "clipboardCopied": "Copied to Clipboard",
        "clipboardFailed": "Clipboard not supported",
        "image": "Image",
        "imageUploadFormat": "File formats: JPG, PNG. Max file size: {{size}}",
        "images": "Images",
        "users": "Users",
        "location": "Location",
        "locations": "Locations",
        "allLocations": "All locations",
        "channel": "Channel",
        "survey": "Survey",
        "surveys": "Surveys",
        "reviewSites": "Review sites",
        "rating": "Rating",
        "status": "Status",
        "update": "Update",
        "keywords": "Keywords",
        "replyTemplates": "Linked templates",
        "all": "All",
        "url": "URL",
        "or": "or",
        "name": "Name",
        "firstName": "First name",
        "lastName": "Last name",
        "lastNameOpt": "Last name (optional)",
        "fullName": "Full name",
        "phoneNumber": "Phone number",
        "email": "Email",
        "emailAddress": "Email address",
        "login": "Login",
        "password": "Password",
        "outOf": "{{total}} out of {{max}}",
        "saving": "Saving...",
        "edit": "Edit",
        "delete": "Delete",
        "view": "View",
        "duplicate": "Duplicate",
        "deleteTitle": "Confirm deletion",
        "deleteDescription": "Are you sure you want to delete this? This action can not be undone.",
        "delay": "Delay",
        "refresh": "Refresh",
        "contactCreated": "Contact created",
        "liveChat": "Live-chat",
        "left": "Left",
        "right": "Right",
        "file": "File",
        "audio": "Audio",
        "video": "Video",
        "monday": "Monday",
        "tuesday": "Tuesday",
        "wednesday": "Wednesday",
        "thursday": "Thursday",
        "friday": "Friday",
        "saturday": "Saturday",
        "sunday": "Sunday",
        "open": "Open",
        "closed": "Closed",
        "24hours": "24 hours",
        "story": "Story",
        "user": "User",
        "new_other": "New",
        "new_one": "New",
        "unassigned": "Unassigned",
        "title": "Title",
        "scheduledTime": "Scheduled time",
        "scheduled": "Scheduled",
        "published": "Published",
        "unpublished": "Not published",
        "publishing": "Publishing",
        "cancelled": "Cancelled",
        "deleted": "Deleted",
        "description": "Description",
        "completed": "Completed",
        "cancel": "Cancel",
        "subscriptionExpiredMsg": "There was an issue with your subscription. Please check your billing details or contact support.",
        "upgradeToAdd": "Upgrade to add more",
        "planCancelledUntilPeriodEnd": "Your subscription is cancelled and stays active until the end of the paid period. Contact support to reactivate it.",
        "upgradeAskAdmin": "Please ask your account admin to upgrade the plan.",
        "upgradeToUnlock": "Upgrade to unlock this feature",
        "sms": "SMS",
        "whatsApp": "WhatsApp",
        "liveChatLowercase": "live-chat",
        "facebookMessenger": "Facebook Messenger",
        "instagram": "Instagram",
        "templates": "Templates",
        "industry": "Industry",
        "impressions": "Impressions",
        "reach": "Reach",
        "engagement": "Engagement",
        "learnMore": "Learn more",
        "number": "Number",
        "text": "Text",
        "date": "Date",
        "required": "Required",
        "type": "Type",
        "templateName": "Template name",
        "author": "Author",
        "yes": "Yes",
        "no": "No",
        "labels": "Segment",
        "locationLabels": "Location labels",
        "logo": "Logo",
        "low": "Low",
        "medium": "Medium",
        "high": "High",
        "critical": "Critical",
        "average": "Average",
        "good": "Good",
        "excellent": "Excellent",
        "conversations": "Conversations",
        "platform": "Platform",
        "actionRequired": "Action required",
        "conflict": "Conflict",
        "conflicts": "Conflicts",
        "conflict_one": "Conflict",
        "conflict_other": "Conflicts",
        "notFound": "Not found",
        "notVerified": "Not verified",
        "disconnected": "Disconnected",
        "notPublished": "Not published",
        "inProgress": "In progress",
        "synced": "Synced",
        "syncedWithConflicts": "Synced with conflicts",
        "na": "N/A",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "none": "None",
        "reported": "Reported",
        "report": "Report",
        "format": "Format",
        "photo": "Photo",
        "customer": "Customer",
        "business": "Business",
        "category_other": "Categories",
        "category_one": "Category",
        "action": "Action",
        "day": "Day",
        "week": "Week",
        "month": "Month",
        "year": "Year",
        "draft": "Draft",
        "top": "Top",
        "bottom": "Bottom",
        "notifications": "Notifications",
        "complaint_other": "Complaints",
        "complaint_one": "Complaint",
        "review_other": "Reviews",
        "review_one": "Review",
        "location_other": "Locations",
        "location_one": "Location",
        "profile_other": "Profiles",
        "profile_one": "Profile",
        "message_other": "Messages",
        "message_one": "Message",
        "subject": "Subject",
        "cc": "CC",
        "bcc": "BCC",
        "link": "Link",
        "microsite": "Microsite",
        "color_one": "Color",
        "color_other": "Colors",
        "archived": "Archived",
        "assignedTo": "Assigned to",
        "question": "Question",
        "answer": "Answer",
        "copy": "Copy",
        "brands": "Brands",
        "brand": "Brand",
        "failed": "Failed",
        "actions": "Actions",
        "questions": "Questions",
        "language": "Language",
        "localization": "Localization",
        "disabled": "Disabled",
        "active": "Active",
        "day(s)": "day(s)",
        "hour(s)": "hour(s)",
        "minute(s)": "minute(s)",
        "appearance": "Appearance",
        "settings": "Settings",
        "style": "Style",
        "font": "Font",
        "button_one": "Button",
        "button_other": "Buttons",
        "background": "Background",
        "customEvent": "Custom event",
        "unverified": "Unverified",
        "verify": "Verify",
        "noFileSelected": "No file selected",
        "chat": "Chat",
        "customInstructionsOpt": "Custom instructions (optional)",
        "activity": "Activity",
        "information": "Information",
        "newMessage": "New message",
        "frequency": "Frequency",
        "currency": "Currency",
        "coupon": "Coupon",
        "service": "Service",
        "paymentMethods": "Payment methods",
        "externalId": "External ID",
        "public": "Public",
        "publicLink": "Public link",
        "private": "Private",
        "sharedTemplate": "Shared template",
        "template": "Template",
        "teams": "Teams",
        "createdOn": "Created on",
        "platforms": "Platforms",
        "emoji": "Emoji",
        "attachFile": "Attach file",
        "menu": "Menu",
        "form": "Form",
        "team": "Team",
        "recoveryForm": "Recovery form",
        "removedPersonName": "{{name}} (removed)",
        "notSpecified": "Not specified",
        "timesInZone": "Times are in {{timeZone}}."
    },
    "ContactsPage": {
        "createdOn": "Created on",
        "deleteContactsDescription": "Are you sure you want to delete {{selectedContacts}} contacts? This action can not be undone.",
        "facebookProfile": "Facebook profile",
        "instagramProfile": "Instagram profile",
        "createTitle": "Create new contact",
        "createSubtitle": "Add basic information details about the contact",
        "editTitle": "Edit contact",
        "editContactsTitle": "Edit contacts",
        "editBulkContactsSubtitle": "Select properties to edit. The changes will apply to all selected contacts.",
        "mergeContactsTitle": "Merge contacts",
        "mergeContactsSubtitle": "Merge contacts to combine two profiles into one, including all attributes and activity. In case of conflict, the Primary contact’ s attributes will take precedence.",
        "mergeContactPrimary": "Primary contact (To be kept)",
        "mergeContactSecondary": "Contact to merge (To be deleted)",
        "editSubtitle": "Change basic information details about the contact",
        "unsubscribe": "Unsubscribe",
        "unsubscribed": "Unsubscribed",
        "lastActiveOn": "Last active on",
        "importTitle": "Import new contacts",
        "importSubtitle": "Import contacts through a CSV file.",
        "importConsent": "I confirm these contacts agreed to receive messages from my business, and the list was not purchased, rented or obtained from a third party.",
        "bulkFileLink": "Download a sample CSV.",
        "csvFile": "CSV file",
        "importFile": "Import",
        "id": "ID",
        "dataVerificationDescription": "Review the parsed data from the csv file. In order for it to be processed, it must not contain any errors.\n If you found an error close this pop-up, edit and reupload the file.",
        "validate": "Validate",
        "numberToImport": "Contacts to add {{diff}}. Contacts to update {{duplicates}}",
        "contactsToAdd": "Contacts to add",
        "contactsToUpdate": "Contacts to update",
        "noContacts": "No contacts to import",
        "search": "Search",
        "searchLabel": "Search by name, phone or email",
        "activitySurveySent": "Survey sent: {{template}}",
        "activityFormSubmitted": "Submitted form {{name}}",
        "activitySurveyReminder": "Survey reminder sent: {{template}}",
        "activitySurveyResponded": "Responded to {{template}} with {{rating}}-stars",
        "activityMessageSent": "Message sent via {{channel}}",
        "activityConversationStarted": "Conversation started",
        "activityConversationClosed": "Conversation resolved by {{name}}",
        "activityConversationReopened": "Conversation reopened by {{name}}",
        "activityReviewLeft": "Left review on {{reviewType}}",
        "activityIntegrationEvent": "Event from {{integration}}",
        "contacts": "contacts",
        "contactsSelected": "{{selectedContacts}} contacts selected",
        "mergeSuccess": "Contacts have been successfully merged",
        "mergeFail": "Couldn't merge contacts",
        "activityPaymentCompleted": "Payment completed",
        "paymentDetails": {
            "amount": "Amount",
            "location": "Location",
            "paidAt": "Paid",
            "method": "Payment method",
            "account": "Payment account",
            "purchase": "Purchase",
            "firstPurchase": "First",
            "purchaseNumber": "No. {{count}}",
            "viewReceipt": "View receipt",
            "sources": {
                "CARD": "Card",
                "BANK_ACCOUNT": "Bank account",
                "WALLET": "Digital wallet",
                "BUY_NOW_PAY_LATER": "Buy now, pay later",
                "SQUARE_ACCOUNT": "Square balance",
                "CASH": "Cash",
                "EXTERNAL": "Other"
            }
        },
        "sex": "Sex",
        "sexFemale": "Female",
        "sexMale": "Male",
        "dateOfBirth": "Date of birth",
        "language": "Language",
        "dateOfBirthWithoutYear": "Stored as {{date}}, without a year",
        "leaveUnchanged": "Leave unchanged",
        "activityAddedToSegment": "Added to segment {{name}}"
    },
    "ErrorsPages": {
        "notFoundPage": "We couldn't find the page you're looking for",
        "titleSomethingWrong": "We couldn’t load this page",
        "textSomethingWrong": "Sorry for the inconvenience. We’re aware of this problem and already looking at the cause of the issue. If the problem isn’t resolving, email us to help@pluspoint.io for immediate support."
    },
    "FeedbackResponses": {
        "newReviews": "New reviews are available. <0>{{update}}</0>",
        "update": "UPDATE",
        "noDataMessage": "NA",
        "onlyRating": "The customer didn't write a review and has left just a rating.",
        "aiReviewTags": "Liked most",
        "contactDetailsOnly": "The customer left their contact details without a message.",
        "copyNumber": "Copy phone number",
        "callNumber": "Call phone",
        "chatViber": "Reach out via Viber",
        "chatWhatsApp": "Reach out via WhatsApp",
        "copyEmail": "Copy email",
        "chatEmail": "Reach out via email",
        "ticketStatus": "Ticket status",
        "completed": "Completed",
        "viaCoverManager": "Via CoverManager",
        "hideAnonimous": "Hide anonymous responses",
        "linkedReview": "Linked review"
    },
    "FeedbackSurveys": {
        "created": "Surveys created:",
        "createdQrOnly": "QR codes created:",
        "title": "Manage your surveys",
        "subtitle": "Set up surveys to gather valuable feedback from your customers, understand their needs better, and take steps to ensure they stay loyal and recommend your business to others",
        "titleQrOnly": "Unlock smarter review collection",
        "subtitleQrOnly": "Upgrade to Pluspoint Professional for smarter review collection. Send surveys by email, SMS or WhatsApp, route happy customers to public reviews, collect private feedback, and track NPS trends.",
        "responses": "Responses:",
        "views": "Views:",
        "modalTitle": "Edit survey — {{surveyName}}",
        "surveyName": "Survey name",
        "contactDetails": "Contact details",
        "contactEmail": "Contact email",
        "contactPhone": "Contact phone",
        "contactName": "Contact name",
        "contactFormPlacement": "Show contact form on",
        "contactFormMainScreen": "Main screen",
        "contactFormMainScreenDescription": "Everyone who rates sees the contact form.",
        "contactFormNegativeScreen": "Negative screen",
        "contactFormNegativeScreenDescription": "Only respondents who rate below the threshold see the contact form.",
        "contactFormNoFields": "Turn on at least one field below to show the contact form.",
        "addField": "Add field",
        "deleteField": "Delete field",
        "reviewSites": "Review sites",
        "fillColor": "Fill",
        "topText": "Top text",
        "bottomText": "Bottom text",
        "messageTemplate": "Message template",
        "emailSubject": "Email subject",
        "protectionLabel": "Over-survey protection",
        "protectionTooltip": "Set this option to prevent the system from sending multiple invites to the same phone number over a specified period of time.",
        "day": "1 day",
        "days3": "3 days",
        "week": "1 week",
        "weeks2": "2 weeks",
        "month": "1 month",
        "months3": "3 months",
        "months6": "6 months",
        "year": "1 year",
        "followUpLabel": "Send automatic follow-ups",
        "followUpDescription": "Configure a follow-up request that will be automatically sent if no response is given within a selected number of days",
        "wait": "Wait",
        "days": "days then send",
        "followUpMessage": "Follow-up message",
        "main": "Main",
        "positive": "Positive",
        "negative": "Negative",
        "neutral": "Neutral",
        "tabSettings": "Settings",
        "tabSharing": "Sharing",
        "qrCode": "QR code",
        "enableSendSurveys": "Enable send surveys",
        "enableSendSurveysDescription": "Allow this survey to be sent to customers via campaigns, inbox, and the Send Survey feature",
        "customizeQrCodeDesign": "Customize QR design",
        "surveyQuestions": "Survey questions",
        "addQuestion": "Add question",
        "questionsDescription": "Create personalized survey questions to better understand customer needs.",
        "brandSettings": "Brand settings",
        "changeAppearance": "You can change the appearance in <0>{{brandSettings}}</0>.",
        "addFirstQuestion": "Add a question to enable preview.",
        "page": "Page",
        "addPage": "Add page",
        "emptyPageHint": "Drag a question here",
        "nps": "Enable satisfaction scoring (NPS)",
        "customerSatisfaction": "Ask for a rating",
        "ratingScale": "Rating scale:",
        "fiveStar": "1–5 Stars",
        "npsScale": "0–10 Score",
        "enableNpsToAddQuestions": "Enable satisfaction scoring in Settings to add questions",
        "sendableSurveyRequired": "Requires a survey with send surveys enabled",
        "satisfactionSurveyThreshold": "Intercept negative comments if rating is below:",
        "labelsTitle": "Segments",
        "labelsSubtitle": "Assign segments to contacts collected through this survey",
        "typeRating": "Rating",
        "typeSingleChoice": "Single choice",
        "typeYesNo": "Yes / No",
        "typeMultiSelect": "Multi-select",
        "typeShortAnswer": "Short answer",
        "typeParagraph": "Long text",
        "typeDate": "Date",
        "questionType": "Question type",
        "addOption": "Add option",
        "optionLabel": "Option",
        "gateQuestion": "Gate question",
        "gateQuestionTooltip": "Skip remaining questions if 'No' is selected.",
        "gateRequiresTooltip": "Unavailable when Gate question is enabled.",
        "showConditionally": "Show based on previous answer",
        "showConditionallyTooltip": "Show this question only when specific answers are given to previous questions. Multiple rules use AND logic (all must match).",
        "conditionShowIf": "Show this question only if",
        "conditionAndIf": "AND if",
        "conditionMatches": "matches",
        "addCondition": "Add condition",
        "star": "star",
        "stars": "stars",
        "yes": "Yes",
        "no": "No",
        "other": "Other",
        "includeOtherOption": "Include \"Other\" option",
        "customWording": "Custom survey wording",
        "aiReviewSuggestions": "AI review suggestions",
        "aiReviewSuggestionsTooltip": "Visitors who rate you well pick what they liked, and Pulse AI drafts a short review they can copy to Google and the other review sites.",
        "aiReviewTags": "Tags visitors can pick",
        "addReviewTag": "Add tag",
        "reviewTagNamePlaceholder": "New tag name",
        "createReviewTag": "Create",
        "editReviewTagTitle": "Edit tag",
        "deleteReviewTagTitle": "Delete tag?",
        "deleteReviewTagDescription": "\"{{name}}\" will be deleted for the entire account and removed from all surveys.",
        "useCustomWording": "Use custom wording",
        "customWordingTooltip": "Add custom text for each language you want the survey to support. A language will only appear in the survey if text is provided for it.",
        "positiveMessage": "Positive message",
        "negativeMessage": "Negative message",
        "localizationSingleLanguage": "Add languages under Custom survey wording in Settings to translate questions"
    },
    "filters": {
        "labels": "Location labels",
        "companies": "Locations",
        "locations": "Locations",
        "surveys": "Surveys",
        "integrations": "Review sites",
        "channels": "Channels",
        "platforms": "Platforms",
        "timeframe": "Timeframe",
        "rating": "Rating",
        "statuses": "Status",
        "views": "Status",
        "hideAnonimous": "Enable to see only responses with contact information",
        "keywords": "Keywords",
        "withoutReplies": "Reviews without replies",
        "onlyFeatured": "Featured reviews",
        "formats": "Format",
        "categories": "Category",
        "authors": "Author",
        "contactLabels": "Segment",
        "grouping": "Group by",
        "brands": "Brands",
        "showUnreadOnly": "Show only unread conversations",
        "sorting": "Order by",
        "teams": "Teams",
        "sexes": "Sex",
        "languages": "Language",
        "birthMonths": "Birthday month",
        "ageBracket": "Age",
        "anyAge": "Any age"
    },
    "ForgotPasswordPage": {
        "title": "Forgot password?",
        "description": "Enter your email address. We will send you a link to reset your password.",
        "backToLogin": "Back to Log in page",
        "confirmationSuccess": "If a Pluspoint account exists, an email will be sent with further instructions"
    },
    "Header": {
        "home": "Home",
        "reviewsOverview": "Overview",
        "templates": "Templates",
        "responses": "All responses",
        "surveys": "Surveys",
        "reviewsManage": "All reviews",
        "reviewsTemplates": "Reply templates",
        "reviewsAutoreplies": "Auto-replies",
        "reviewsAutomation": "Automation",
        "messagingInbox": "Inbox",
        "messagingTemplates": "Message templates",
        "microsites": "Microsites",
        "menus": "Menus",
        "forms": "Forms",
        "analytics": "Analytics",
        "analyticsConversion": "Conversion Analytics",
        "analyticsReviews": "Reviews Analytics",
        "analyticsSurveys": "Responses Analytics",
        "analyticsConversations": "Conversations",
        "analyticsPresence": "Presence",
        "settings": "Settings",
        "onboarding": "Onboarding",
        "reviewsWidgets": "Website widgets",
        "socialPosts": "Posts",
        "keywords": "Keywords & Sentiment",
        "ordersIfood": "Orders",
        "campaigns": "Campaigns",
        "campaignsAutomated": "Automated",
        "campaignsOneTime": "One-time",
        "contacts": "Contacts",
        "presence": "Presence",
        "presenceProfiles": "Profiles",
        "presenceMedia": "Photos and videos",
        "locationsManage": "Manage locations",
        "locationsProfiles": "Profiles",
        "locationsMedia": "Photos & Videos",
        "visibilityScanner": "Visibility Scanner",
        "locationsAnalytics": "Locations Analytics",
        "login": "Log in",
        "signup": "Sign up",
        "resetPassword": "Reset password",
        "forgotPassword": "Forgot password?",
        "verifyEmail": "",
        "acceptInvitation": "Accept invitation",
        "error": "Error",
        "pulseAI": "Pulse AI",
        "coupons": "Coupons",
        "campaignsLibrary": "Library"
    },
    "HomePage": {
        "leaderboard": "Leaderboard",
        "5LocationsBy": "5 locations by",
        "rating": "rating",
        "reviews": "reviews",
        "nps": "NPS",
        "inbox": "Inbox",
        "surveys": "Survey responses",
        "recommendations": "Recommendations",
        "presence": "Online Presence",
        "locations": "Online presence",
        "synchronization": "Profile sync",
        "optimizationScoreSubtitle": "Spot locations with incomplete profiles to boost discoverability and customer trust",
        "locationsSubtitle": "See how customers find and engage with your locations across the web",
        "synchronizationSubtitle": "Keep your business details consistent everywhere customers search for you",
        "leaderboardSubtitle": "See which locations lead and which need support to lift overall performance",
        "inboxSubtitle": "Reply to customer messages from every channel in one place",
        "reviewsSubtitle": "Stay on top of new reviews and grow your reputation by responding fast",
        "surveysSubtitle": "Capture feedback to spot complaints early and improve customer experience",
        "socialSubtitle": "Engage your audience with consistent posts and track what reaches customers",
        "surveysTitle": "Manage customer feedback and complaints",
        "unreplied": "Unreplied",
        "vsPrevMonth": "<0>{{percentage}}</0> vs previous month",
        "getStarted": "Get started with {{steps}} easy steps",
        "continueOnboarding": "Continue onboarding",
        "googleTitle": "Integrate with Google My Business (5 min)",
        "googleDescription": "Manage and respond to customer reviews and update public information.",
        "brandTitle": "Create a brand (5 min)",
        "brandDescription": "Group locations for easier management and customize appearance across the platform.",
        "channelsTitle": "Set up communication channels (20 min)",
        "channelsDescription": "Consolidate live chat and messaging platforms for streamlined customer communication.",
        "templatesTitle": "Create survey templates (10 min)",
        "templatesDescription": "Enable surveys to capture essential customer feedback and grow online reviews.",
        "qrCodesTitle": "Create review QR codes (5 min)",
        "qrCodesDescription": "Generate QR codes to place on receipts, tables, or windows so customers can leave a review on the spot.",
        "autoRepliesTitle": "Configure review auto-replies (10 min)",
        "autoRepliesDescription": "Automate personalized responses to reviews for higher engagement and customer care.",
        "usersTitle": "Invite other users (5 min)",
        "usersDescription": "Expand your team's capabilities by inviting colleagues to the platform.",
        "recommendation1Title": "Reply to the latest reviews",
        "recommendation1Subtitle": "There are reviews that haven't been answered.",
        "recommendation1Text": "By responding to reviews, you help improve your locations' star rating.",
        "recommendation1UrlText": "Go to reviews",
        "recommendation2Title": "Update the photos on your profiles",
        "recommendation2Subtitle": "The photos haven't been updated for over a month.",
        "recommendation2Text": "Current photos will help enhance your online presence.",
        "recommendation2UrlText": "Go to photos",
        "recommendation3Title": "Add descriptions to your locations",
        "recommendation3Subtitle": "Some of your profiles do not have descriptions.",
        "recommendation3Text": "A complete description improves the ranking of your profile in search results.",
        "recommendation3UrlText": "Go to settings",
        "recommendationLocationsUrlText": "Go to locations",
        "recommendation4Title": "Resolve profile conflicts and publish missing listings",
        "recommendation4Subtitle": "Some profiles require your attention.",
        "recommendation4Text": "Resolve conflicts to keep your data consistent and publish profiles that aren't live yet so customers can find you.",
        "recommendation4UrlText": "Go to profiles",
        "recommendation5Title": "Reply to unread messages",
        "recommendation5Subtitle": "You have unread messages that need your attention. ",
        "recommendation5Text": "Responding promptly enhances your customer satisfaction.",
        "recommendation5UrlText": "Go to inbox",
        "recommendation6Title": "Publish a social post",
        "recommendation6Subtitle": "Some profiles haven't had a new post in a while.",
        "recommendation6Text": "Regular social posts keep your audience engaged and improve your online presence.",
        "recommendation6UrlText": "Go to social posts",
        "recommendation7Title": "Review recent complaints",
        "recommendation7Subtitle": "There are unresolved complaints from your customers.",
        "recommendation7Text": "Addressing complaints promptly helps improve customer satisfaction and trust in your company.",
        "recommendation7UrlText": "Go to complaints",
        "recommendation8Title": "Integration disconnected",
        "recommendation8Text": "The integration between a review platform and Pluspoint is currently disconnected. Please reconnect to continue using the integration correctly.",
        "recommendation9Title": "Channel disconnected",
        "recommendation9Text": "A communication channel is currently disconnected. Reconnect to ensure all client messages and responses are delivered without interruption.",
        "recommendation10Title": "Automated campaign failed",
        "recommendation10Text": "An automated campaign has failed to execute. Check the automation settings to identify and resolve the issue.",
        "recommendation10UrlText": "Go to campaigns",
        "recommendation11Title": "One-time campaign failed",
        "recommendation11Text": "Your one-time campaign failed to send. Please review the campaign details and try again.",
        "showAllRecommendation": "Show all recommendations",
        "showLessRecommendation": "Don't show hidden recommendations"
    },
    "IfoodOrders": {
        "orderId": "Order ID",
        "accountId": "Account ID",
        "orderType": "Order type",
        "merchant": "Merchant",
        "createdAt": "Created at",
        "customerName": "Customer",
        "customerPhoneNumber": "Customer phone number",
        "paymentInformation": "Payment information",
        "expireAt": "expire at:"
    },
    "Listings": {
        "modalTitleGoogle": "Manage Google My Business Profile",
        "modalTitleFacebook": "Manage Facebook Profile",
        "about": "About",
        "name": "Name",
        "openingDate": "Opening date",
        "contact": "Contact",
        "primaryPhone": "Primary phone",
        "additionalPhone": "Additional phone",
        "website": "Website",
        "businessHours": "Business hours",
        "categories": "Categories",
        "primaryCategory": "Primary category",
        "secondaryCategory_one": "Secondary category",
        "secondaryCategory_other": "Secondary categories",
        "enableProfileSync": "Enable profile sync",
        "disableProfileSync": "Disable profile sync",
        "connectMainPage": "Connect main page",
        "storeLocation": "Store location",
        "connectStoreLocation": "Connect store location",
        "ignoredFields": "Ignored fields",
        "ignoredFieldsHint": "Pluspoint neither pushes these fields to this listing nor reports them as conflicts.",
        "currentlyDifferent": "currently different"
    },
    "LoginPage": {
        "title": "Welcome back",
        "description": "Access your locations, reviews, and messages in one place.",
        "forgotPassword": "Forgot your password?",
        "notRegistered": "Don't have an account? <0>{{link}}</0>",
        "signUp": "Sign up",
        "terms": "Terms of Use,",
        "privacy": "Privacy Policy",
        "dpa": "Data Processing Agreement",
        "termsConditions": "By using Pluspoint you agree to <0>{{terms}}</0> <1>{{privacy}}</1> and <2>{{dpa}}</2>",
        "signinWithGoogle": "Sign in with Google",
        "googleUserNotFound": "No account found with this email. <0>{{link}}</0> to get started."
    },
    "LogoutModal": {
        "logOutConfirmation": "Log out of Pluspoint?",
        "logOutConfirmationDescription": "You will be returned to the login screen"
    },
    "DnsRecordCard": {
        "type": "Type:",
        "name": "Name:",
        "value": "Value:",
        "status": "Status:",
        "notChecked": "Not checked"
    },
    "MicrositesPage": {
        "createCustomLending": "Create a custom landing page for every location",
        "createCustomLendingSubTitle": "Create mobile-first landing pages for each location to provide customers with the information they need, like contact information, services list, reservations, and social media links.",
        "created": "Micro-sites created:",
        "content": "Content",
        "modalTitle": "Edit microsite",
        "codeName": "Microsite name",
        "displaySocialMediaLinks": "Display social media links",
        "showReviews": "Display rating & reviews",
        "links": "Links, surveys & forms",
        "linksSubtitle": "Create a microsite by adding external links, surveys and forms",
        "visits": "Visits:",
        "additionalSettings": "Additional settings",
        "showLiveChat": "Display live-chat",
        "surveyNotAvailableForBrand": "Surveys are not supported for brands. Remove this link.",
        "micrositeNotAvailableForLocation": "Microsite links are not supported for locations. Remove this link.",
        "surveyNotAvailableForLocation": "Survey not available for this location. Select another or remove.",
        "micrositeNotAvailableForBrand": "Microsite not available for this brand. Select another or remove.",
        "customDomain": "Custom Domain",
        "customDomainCaption": "Serve this microsite from your own domain instead of plsp.io",
        "useCustomDomain": "Use custom domain",
        "domain": "Domain",
        "statusPending": "Pending",
        "statusActive": "Active",
        "statusFailed": "Failed",
        "noDomainsInAccount": "No domains in your account",
        "noDomainsAvailable": "No domains available. Contact your admin to add a custom domain.",
        "addNewDomain": "Add new domain",
        "addCustomDomain": "Add Custom Domain",
        "enterDomainDescription": "Enter the domain you want to use for your microsites.",
        "domainOwnershipNote": "The domain must be one you own. You'll need to add a CNAME record to verify ownership. To use a root domain, your DNS provider must support CNAME flattening.",
        "dnsInstructions": "Add this CNAME record at your domain provider to point your domain to Pluspoint.",
        "domainRequired": "Domain is required",
        "domainLengthError": "Domain must be between 4 and 253 characters",
        "domainInvalidFormat": "Enter a valid domain",
        "domainPluspoint": "Pluspoint domains cannot be used as custom domains",
        "addDomain": "Add Domain",
        "editDomain": "Edit Domain — {{hostname}}",
        "status": "Status:",
        "lastChecked": "Last checked:",
        "micrositesUsingDomain": "Microsites using this domain:",
        "checkStatus": "Check Status",
        "checking": "Checking...",
        "checkStatusError": "Unable to check domain status. Please try again.",
        "deleteCustomDomain": "Delete Custom Domain",
        "deleteConfirm": "Permanently delete {{hostname}}?",
        "deleteImpact": "This domain is used by {{count}} microsite(s). They will lose their custom URL and only be accessible via plsp.io.",
        "deleteWarning": "This action cannot be undone. You will need to re-add and re-verify the domain to use it again.",
        "domainDeleted": "Custom domain deleted",
        "deleteError": "Failed to delete domain",
        "addDomainError": "Unable to register domain. Please try again later.",
        "loadError": "Failed to load custom domains",
        "menuNotAvailable": "Menu not available for this microsite. Select another or remove.",
        "formNotAvailable": "Form not available for this microsite. Select another or remove.",
        "menuNotAvailableForBrand": "Menus are not available on brand microsites. Remove this link."
    },
    "ContactFieldsSettings": {
        "identifyingFieldRequired": "A phone or an email must stay required"
    },
    "FormsPage": {
        "title": "Turn visits into lasting relationships",
        "subtitle": "Collect customer details through customizable forms and use them to build your contact lists, segment audiences, and run targeted campaigns.",
        "created": "Forms created:",
        "createForm": "Create form",
        "modalTitle": "Form",
        "internalName": "Form name",
        "downloadSubmissions": "Download submissions",
        "confirmationMessage": "Confirmation message",
        "defaultConfirmationMessage": "Thank you for submitting the form",
        "views": "Views:",
        "submissions": "Submissions:",
        "contactFields": "Contact fields",
        "contactFieldsSubtitle": "Choose which details the form asks for and which are mandatory.",
        "deleteForm": "Delete form"
    },
    "LocalizeItemModal": {
        "defaultLanguages": "Default language",
        "additionalLanguages": "Additional languages"
    },
    "multiSelectLabels": {
        "done": "Done",
        "manage": "Manage",
        "createNewLabel": "Create new segment",
        "searchLabel": "Search or create new segments"
    },
    "GoogleLocationsList": {
        "searchLabel": "Search",
        "hideConnected": "Hide already connected",
        "hideUnverified": "Hide unverified",
        "noMatches": "No matching locations",
        "allConnected": "All locations are already connected"
    },
    "OnboardingPage": {
        "titleFirst": "Welcome to Pluspoint!",
        "subtitleFirst": "Let’s start with your basic details so we can set up your workspace and personalize your experience.",
        "titleSecond": "Connect your Google account",
        "subtitleSecond": "Link your Google Business Profile to import and manage your locations in Pluspoint. Make sure to select all permissions. This ensures Pluspoint can sync your locations correctly and manage reviews on your behalf.",
        "buttonConnectWithGoogle": "Connect with Google",
        "titleGoogleEmpty": "No locations found",
        "subtitleGoogleEmpty": "We couldn’t detect any Google Business locations linked to this account. Try connecting a different Google account or confirm that all permissions were selected during the authorization step.",
        "titleManual": "Add your first location",
        "subtitleManual": "Enter your location name and address. Later you can add more locations in the Listings menu.",
        "titleGoogle": "Select locations to import",
        "subtitleGoogle": "Choose the locations you want to bring into Pluspoint. You can import one or multiple locations to start managing reviews, messages, and profiles.",
        "canTryNextFull": "Not the list that you are looking for? You can try next:",
        "canTryNext": "Not the list that you are looking for? Connect another Google account:",
        "success": "Success!"
    },
    "AcceptInvitationPage": {
        "title": "Set up your account",
        "description": "You've been invited to join Pluspoint",
        "continueWithGoogle": "Continue with Google",
        "emailMismatch": "The Google account email doesn't match the invitation email. Please try again with the correct account.",
        "tokenExpired": "This invitation link has expired. Please contact your administrator for a new invitation.",
        "alreadyAccepted": "This invitation has already been accepted. Please log in."
    },
    "ResetPasswordPage": {
        "titleReset": "Reset password",
        "titleChanged": "Password changed",
        "descriptionReset": "Enter a new password for your account",
        "descriptionChanged": "Your password has been successfully changed. Now you can log in to your account using new password.",
        "confirmPassword": "Confirm password"
    },
    "ReviewsAutoreplies": {
        "instantlyRespond": "Instantly respond to customer reviews",
        "googleConnected": "Setup automatic replies to Google reviews that will be triggered when certain conditions are met",
        "subtitleWithManualSupport": "Set up AI-powered replies for customer reviews. Customize suggestions across all review sources and automatically post replies to Google reviews.",
        "created": "Auto-replies created:",
        "ruleName": "Name",
        "containsMessage": "Doesn’t contain message",
        "addRule": "Add new auto-reply",
        "editRule": "Edit auto-reply",
        "viewRule": "Auto-reply details",
        "reviewType": "Review type",
        "withComment": "With comment",
        "withoutComment": "Without comment",
        "applyToPastReviews": "Apply to past unreplied reviews",
        "enableAI": "Enable Pulse AI auto-replies for new reviews",
        "enableAIDescription": "Pulse AI auto-replies may generate inaccurate or inappropriate responses. By enabling this option, you acknowledge the risks and accept responsibility for monitoring and managing replies.",
        "pulseAiDescription": "Add custom instructions to shape AI-generated replies. They apply when you click Write Reply on any review, and to auto-replies on Google reviews when the toggle below is on.",
        "createNewTemplate": "Create new template",
        "sendRecoveryForm": "Send recovery form",
        "sendRecoveryFormDescription": "Replies to reviews rated 1 to 4 end with a link to a private form where the reviewer can leave their contact details."
    },
    "ReviewsEmptyFeed": {
        "reviewsNotSelectedTitle": "You haven't selected any source",
        "integrationDescription": "review site",
        "surveyDescription": "survey",
        "reviewsAreLoadingTitle": "Your reviews are being loaded to Pluspoint",
        "reviewsAreLoadingDescription": "It usually takes a few minutes",
        "reviewsNotSelectedDescription": "Select a valid location, {{feedback}} and rating in the filter",
        "reviewsNotExistTitle": "You haven’t received any reviews yet",
        "reviewsNotExistDescriptionEx": "<0>{{sendSurveys}}</0> or <1>{{setupSurvey}}</1> to start getting more reviews",
        "sendSurveys": "Send surveys",
        "setupSurvey": "Set-up Surveys"
    },
    "ReviewsManage": {
        "newReviews": "New reviews are available. <0>{{update}}</0>",
        "update": "UPDATE",
        "withoutReplies": "Show only reviews without replies",
        "noTextMsg": "No text provided",
        "onlyRating": "The customer didn't write a review and has left just a rating.",
        "repliedOn": "Replied on {{date}}",
        "replied": "Replied",
        "repliedOnByUser": "{{name}} replied on {{date}}",
        "repliedByUser": "{{name}} replied",
        "viewOn": "View on {{integration}}",
        "editReply": "Edit Reply",
        "unverifiedListingNotice": "This listing isn't verified in Google Business Profile, so Google doesn't accept replies.",
        "verifyListingAction": "Verify the listing",
        "replyingAsOwner": "Replying as business owner",
        "publishReply": "Publish Reply",
        "yourReply": "Your reply",
        "unresolvedPlaceholders": "Your reply contains a placeholder that can't be filled in: {{placeholders}}. Remove it before publishing.",
        "viaOn": "via {{integration}} on {{date}}",
        "locationsCount": "{{count}} locations",
        "assignContact": "Assign contact",
        "markAsReplied": "Mark as replied",
        "replyingOnExternal": "Replying on external site",
        "manuallyRepliedOn": "Manually replied on {{date}}",
        "manuallyReplied": "Manually replied",
        "manuallyRepliedOnByUser": "{{name}} manually replied on {{date}}",
        "manuallyRepliedByUser": "{{name}} manually replied",
        "translate": "Translate",
        "showOriginal": "Show original",
        "translatedByGoogle": "Translated by Google",
        "markAsFeatured": "Mark as featured",
        "removeFromFeatured": "Remove from featured",
        "markAsDeleted": "Mark as deleted",
        "unmarkAsDeleted": "Unmark as deleted",
        "markedAsDeleted": "Review marked as deleted",
        "unmarkedAsDeleted": "Review unmarked as deleted",
        "reviewStatus": {
            "updated": "Updated",
            "deleted": "Deleted",
            "featured": "Featured"
        }
    },
    "RespondTemplate": {
        "insertTemplate": "Insert template",
        "noSavedTemplates": "No saved templates",
        "saveReplyAsTemplate": "Save reply as template",
        "deleteTemplate": "Delete template",
        "overwriteTemplate": "Overwrite template",
        "saveAsNewTemplate": "Save as new template",
        "saveNewTemplate": "Save new template",
        "editTemplate": "Edit template?",
        "editTemplateDescription": "This will override your template."
    },
    "ReviewsReplyTemplates": {
        "tenfoldProductivity": "Tenfold your team productivity with canned responses",
        "googleConnected": "Manage and update canned responses to Google reviews",
        "created": "Templates created:",
        "templateMessage": "Template message",
        "linkedAutoreplies": "Linked autoreplies",
        "addTemplate": "Add new reply template",
        "editTemplate": "Edit reply template",
        "viewTemplate": "Reply template details",
        "messageInputText": "Enter your message template in the below message box. You can use placeholders [name] and [location] that will be automatically replaced with the reviewer's first name and the name of your location where the review has been made. Insert the recovery form link from the same menu to invite the reviewer to leave their contact details."
    },
    "SendInvites": {
        "sendSurvey": "Send survey",
        "sendSurveys": "Send surveys",
        "personal": "Personal",
        "bulk": "Bulk",
        "phoneEmail": "Phone number or email",
        "from": "From",
        "messageSent": "Invite has been successfully sent",
        "messagesSent": "invites have been successfully sent",
        "bulkDescription1": "You can import up to 1,000 customers you’d like to send your review invites to.",
        "bulkDescription2": "To see the correct structure of the CSV file, you can",
        "bulkFileLink": "download sample file",
        "dataVerification": "Data verification",
        "dataVerificationDescription": "Review the parsed data from the csv file. In order for it to be processed, it must not contain any errors. If you found an error close this pop-up, edit and reupload the file. If a contact has both email and phone number, they will receive a text message.",
        "id": "ID",
        "import": "Import {{amount}} contacts",
        "contactsAdded": "contacts added.",
        "viewContacts": "View contacts",
        "addedContacts": "Added contacts"
    },
    "SettingsTabs": {
        "profile": "Profile",
        "general": "Account",
        "companies": "Locations",
        "channels": "Channels",
        "integrations": "Integrations"
    },
    "mcpConnections": {
        "title": "MCP Connections",
        "subtitle": "Apps that can connect to your Pluspoint account through the Model Context Protocol. Revoke any you no longer use.",
        "row": {
            "authorizedBy": "Authorized by {{name}} · {{when}}",
            "authorizedByNoDate": "Authorized by {{name}}",
            "lastUsed": "Last used: {{when}}",
            "lastUsedNever": "Last used: never",
            "verified": "Verified vendor"
        },
        "empty": {
            "title": "No MCP connections yet.",
            "body": "Paste {{url}} into Claude.ai, ChatGPT, or another MCP client to connect. We'll ask you to authorize first."
        },
        "howTo": {
            "title": "How to connect",
            "body": "Paste this URL into your MCP client:",
            "guide": "Step-by-step guide for Claude, ChatGPT and other assistants"
        },
        "revoke": {
            "confirmTitle": "Revoke this connection?",
            "confirmBody": "{{name}} will no longer be able to access your Pluspoint account. Active sessions may continue for up to 1 hour while existing access tokens expire. The connection will need to be re-authorized to restore access.",
            "success": "{{name}} has been revoked."
        },
        "errors": {
            "fetchFailed": "Couldn't load MCP connections.",
            "revokeFailed": "Couldn't revoke this connection."
        }
    },
    "SettingsIntegrations": {
        "manageIntegration": {
            "title": "Manage integration",
            "subtitle": "Connect each profile from this account to a Pluspoint location.",
            "connectToLocation": "Connect to location",
            "dontConnect": "Don't connect",
            "createNew": "Create a new location",
            "emptyProfiles": "No profiles found for this account.",
            "loadError": "We couldn't load profiles for this account. Please try again.",
            "retry": "Retry",
            "singleProfilePrompt": "Choose a location to attach this account to",
            "inactiveLocation": "Inactive in Square"
        },
        "connected": "Connected",
        "notConnected": "Not connected",
        "integrations": "Integrations",
        "googleNoLocations": "No locations found. Select another Google Account",
        "iFoodTitle": "Connect iFood account",
        "iFoodSubtitle": "Manage iFood reviews and send surveys to iFood clients",
        "iFoodInstructions": "Enter the CNPJ for each location in iFood.",
        "vtexTitle": "Connect your VTEX account",
        "vtexSubtitle": "In order to integrate your VTEX account with our platform and enable automated post-purchase surveys, we need you to provide the necessary access credentials. This includes an App Key and an App Token. <0>{{link}}</0> on how to retrieve them.",
        "instructionsLink": "Read our instructions",
        "accountName": "Account name",
        "appToken": "Application Token",
        "appKey": "Application Key",
        "coverManagerTitle": "Connect your CoverManager account",
        "coverManagerSubtitle": "Enter your ApiKey to connect your CoverManager account to Pluspoint",
        "apiKey": "apiKey",
        "deleteIntegration": "Delete integration?",
        "deleteIntegrationMessage": "This integration will be deleted from your account. Do you wish to proceed?",
        "addIntegration": "Add integration",
        "columnPlatform": "Platform",
        "columnAccount": "Account",
        "columnStatus": "Status",
        "columnActions": "Actions",
        "noIntegrationsTitle": "No integrations yet",
        "noIntegrationsDescription": "Connect your first integration to start syncing data.",
        "searchPlaceholder": "Search integrations",
        "requestIntegrationTitle": "Can't find your integration?",
        "requestIntegrationDescription": "Request it and we'll look into it — or connect using Zapier or our API.",
        "requestIntegrationSuccess": "Thanks! Your integration request has been sent.",
        "requestIntegrationError": "Couldn't send your request",
        "connectViaApi": "Connect via API",
        "connectViaZapier": "Connect via Zapier",
        "headerTitle": "Connect your platforms",
        "headerSubtitle": "Connect the platforms you already use — Google, social media, messengers and CRMs — to sync reviews, publish posts, manage conversations and keep customer data in one place.",
        "requestNamed": "Request to add “{{name}}”"
    },
    "SettingsProfile": {
        "alertsAndReports": "Alerts and reports",
        "settingsTitle": "Profile & personal settings",
        "profilePhoto": "Profile photo",
        "generalInfo": "General information",
        "systemLanguage": "System language",
        "currentPassword": "Current password",
        "newPassword": "New password",
        "confirmPassword": "Confirm new password",
        "passwordResetText": "Forgot current password?",
        "passwordResetUrl": "Set a new password",
        "everyHour": "Hourly",
        "everyDay": "Daily",
        "everyWeek": "Weekly",
        "everyMonth": "Monthly",
        "emptyNumberTooltip": "Enter your phone number to receive SMS alerts",
        "emailNotifications": "Notification emails",
        "emailNotificationsDescription": "Receive updates and alerts directly to your email.",
        "profileSyncConflicts": "Profile sync conflicts",
        "newReviews": "New reviews",
        "newMessages": "Unassigned messages",
        "newSurveyResponses": "New survey responses",
        "performanceReports": "Performance reports",
        "performanceReportsDescription": "Get regular reports on your account’s performance.",
        "smsNotifications": "SMS alerts about complaints",
        "smsNotificationsDescription": "Get texts when customers leave negative survey response.",
        "browserNotifications": "Browser notifications",
        "browserNotificationsDescription": "Receive new message alerts directly on your device.",
        "pushMessagesSnackbar": "Enable browser notifications to receive new message alerts directly on your device. <0>{{enable}}</0>",
        "serviceWorkerUpdate": "A new version of Pluspoint is available. <0>{{refresh}}</0>",
        "bumpVersion": "New version available. Please refresh your screen. <0>{{refresh}}</0>",
        "installApp": "Install app",
        "installAppDescription": "Install Pluspoint on your device for quick access.",
        "installIosInstructions": "Open this page in Safari, tap the Share icon, then tap \"Add to Home Screen\".",
        "installed": "Installed"
    },
    "SettingsGeneral": {
        "apiDocumentation": "API documentation",
        "accountNameOwnership": "Account name & ownership",
        "linkTracking": "Link tracking",
        "linkTrackingDescription": "See in your analytics how many visitors come to your website from your Google, Facebook and directory listings. Pluspoint adds the tracking tags to each listing's website link for you.",
        "trackingTagsEnabled": "Tag listing links",
        "trackingTagsSource": "utm_source",
        "trackingTagsMedium": "utm_medium",
        "trackingTagsCampaign": "utm_campaign",
        "trackingTagsContent": "utm_content",
        "trackingTagsPreview": "Example for a Google listing",
        "accountName": "Account name",
        "accountOwner": "Account owner",
        "accountLocale": "Locale",
        "billing": "Billing",
        "upgradePluspointSubscription": "Upgrade your Pluspoint subscription",
        "currentPlan": "Current plan",
        "endsOn": "ends on",
        "endedOn": "ended on",
        "daysLeft_one": "day left",
        "daysLeft_other": "days left",
        "upgradeDescription": "Please select the plan, billing period and amount of locations to proceed:",
        "numberOfCompanies": "Number of locations",
        "annual": "Annual",
        "monthly": "Monthly",
        "proceedToPayment": "Proceed to payment",
        "pricePerCompany": "Price per location:",
        "totalPrice": "Total price",
        "month": "month",
        "year": "year",
        "nextPaymentOn": "Next payment on",
        "cancelsOn": "Cancels on",
        "upgradePlan": "Upgrade plan",
        "changePlan": "Change plan",
        "changeDescription": "Select the pricing plan, billing cycle, and the number of locations and users.",
        "numberOfUsers": "Number of users",
        "onlineListings": "Online Listings",
        "reviewManagement": "Review Management",
        "inboxAndLiveChat": "Inbox and Live-chat",
        "socialPosting": "Social Posting",
        "microsites": "Microsites",
        "analytics": "Analytics",
        "surveysAndTickets": "Surveys and Tickets",
        "campaigns": "Messaging Campaigns",
        "additionalUsers": "Additional users",
        "currentPrice": "Current price",
        "newPrice": "New price",
        "dueToday": "Due today",
        "proratedOnNextInvoice": "Prorated charges on next invoice",
        "pulseAICredits": "Pulse AI Credits",
        "recurrentCredits": "Recurrent credits",
        "recurrentCreditsDescription": "Usage of your allocated recurrent credits. These reset at the beginning of each billing cycle.",
        "additionalCredits": "Additional credits",
        "additionalCreditsDescription": "Remaining additional credits. These do not expire and stay available until used.",
        "buyCredits": "Buy credits",
        "enableAutoPay": "Enable auto-pay",
        "autoPayDescription": "Automatically purchase credits when your balance drops below a set limit.",
        "creditsLeft": "{{amount}} credits left",
        "creditLimit": "Credit limit",
        "creditsToPurchase": "Credits to purchase",
        "selectAccount": "Select account",
        "twoMonthsFree": "2 months free",
        "perLocationPer": "location / {{period}}",
        "pluspointFeatureEverything": "Every feature included — no tiers, no gates",
        "pluspointFeatureReviews": "Reviews: monitor, reply & win more with AI",
        "pluspointFeatureInbox": "Omni-channel inbox with a 24/7 AI chatbot",
        "pluspointFeatureEngage": "Social posting, campaigns, surveys & coupons",
        "pluspointFeatureAllowances": "{{users}} users and {{credits}} AI credits / month included",
        "minimumLocations": "Minimum {{count}} locations",
        "usersIncluded": "{{count}} included",
        "summaryPlan_one": "{{count}} Location",
        "summaryPlan_other": "{{count}} Locations",
        "summaryAdditionalUsers_one": "{{count}} Additional user",
        "summaryAdditionalUsers_other": "{{count}} Additional users",
        "billToSubscription": "Bill to subscription",
        "directoriesNoneEnrolled": "No locations enrolled yet.",
        "directoriesManagedPerLocation": "Add or cancel Local Directories for each location from its Manage location page.",
        "openLocations": "Open Locations",
        "locationsEnrolled_one": "{{count}} location enrolled",
        "locationsEnrolled_other": "{{count}} locations enrolled"
    },
    "SettingsCompanies": {
        "movedTitle": "Locations have moved",
        "movedDescription": "You can now manage your locations from the main menu.",
        "goToLocations": "Go to Locations",
        "degree": "Degree",
        "office": "Office",
        "menus": "Menus",
        "menuAssignmentFailed": "Location saved, but menu assignment failed. Please try again.",
        "headshotUrl": "Headshot",
        "locationName": "Location name",
        "internalName": "Internal name",
        "primaryPhone": "Primary phone",
        "phoneExtension": "Ext.",
        "addChat": "Add chat",
        "email": "Service email",
        "website": "Website",
        "address": "Address",
        "contact": "Contact",
        "additionalInformation": "Additional information",
        "descriptionShort": "Short description",
        "descriptionMedium": "Medium description",
        "descriptionLong": "Long description",
        "openingDate": "Opening date",
        "businessHours": "Business hours",
        "specialHours": "Special hours",
        "specialHoursNeedBusinessHours": "Special hours need business hours. Switch business hours on and open at least one day to add dates.",
        "coverPhoto": "Cover photo",
        "nationalHealthProviderId": "National Health Provider ID",
        "storeCode": "Store code",
        "certifications": "Certifications",
        "categoriesAndServices": "Categories and Services",
        "city": "City",
        "channels": "Channels",
        "pending": "Pending",
        "createChannel": "Add new channel",
        "showAddress": "Show business address to customers",
        "locatedInToggle": "Located inside another business",
        "locatedInNeedsPin": "Place the map pin to search businesses nearby",
        "locatedIn": "Located in",
        "relationIndependent": "Independent business",
        "locatedInRelationLabel": "Relationship",
        "relationDepartment": "Department",
        "viewOnGoogleMaps": "View on Google Maps",
        "addressLine1": "Address line 1",
        "addressLine2": "Address line 2",
        "postalCode": "Postal code",
        "state": "State",
        "country": "Country",
        "countryLockedByListings": "Locked while directories are connected",
        "countryLockedByGoogle": "Locked while a Google listing is connected",
        "pinFollowsGoogle": "The map pin follows your Google listing. Move it in your Google Business Profile",
        "publishedDirectories_one": "Published ({{count}} Directory)",
        "publishedDirectories_other": "Published ({{count}} Directories)",
        "optimizationScore": "Optimization score",
        "optimizationScoreTooltip": "Measures how well-optimized your location is for online discovery — based on profile fields completeness. Higher scores improve visibility.",
        "integrationName": "Integration name",
        "disconnectIntegration": "Disconnect active integration?",
        "disconnectIntegrationMessage": "You won’t be able to collect reviews through Pluspoint on this platform and see analytics. Do you wish to proceed?",
        "integrations": "Integrations",
        "onlineProfiles": "Online profiles",
        "socialLinks": "Social links",
        "managedByConnection": "Managed by connection",
        "connected": "Connected",
        "notConnected": "Not connected",
        "published": "Published",
        "notPublished": "Not published",
        "generalInfo": "General info",
        "profileURL": "Profile URL",
        "uberEatsReviewsHint": "Uber Eats publishes only a selection of a store's 5-star reviews. Counts and averages in Pluspoint reflect that selection.",
        "bookingExtranetLink": "Booking.com Extranet link",
        "bookingExtranetHint": "Optional. Paste any link from this property's Extranet (admin.booking.com) or the property ID. Replies will open the Extranet reviews page directly.",
        "connectIntegration": "Connect integration",
        "editProfile": "Edit profile",
        "reviewPlatforms": "Review platforms",
        "addReviewPlatform": "Add review platform",
        "connectIntegrationMsg": "Profile was connected",
        "locationPublishedMsg": "Location published. It may take several days for updates to appear across external sites.",
        "profileDisconnected": "Profile was disconnected",
        "atLeastOneProfile": "At least one integration must be enabled",
        "selectLocation": "Select location",
        "connectLocation": "Connect Location",
        "goToIntegrations": "Go to integrations",
        "importCompanies": "Import locations",
        "importCompaniesCount": "Import {{count}} location(s)",
        "selectCompanies": "Please select a locations that you want to import from your Google account:",
        "linkedTo": "Linked to",
        "googleAutocomplete": "Search business on Google",
        "addLocationTitle": "Add new location",
        "addLocationDescription": "Search the Google location you would like to add to Pluspoint and click Add location.",
        "connectDrawerDescription": "Select an appropriate item from the list to link it to the location.",
        "connectDrawerNotConnected": "No Active Integration Found",
        "connectDrawerNotConnectedDescription": "Connect your account in the Integration settings to proceed (Requires 'Global Admin' permissions).",
        "iFoodPendingTitle": "iFood Connection In Progress",
        "iFoodPendingDescription": "Your connection request has been sent to iFood. Locations can be linked once iFood grants access.",
        "title": "Manage all your locations in one place",
        "subtitle": "Keep business details, hours, addresses, and contact info accurate and consistent across all your locations. Add new locations, bulk edit, or import from Google — everything you need to stay organized.",
        "additionalPhone": "Additional phone",
        "additionalPhones": "Additional phones",
        "addPhone": "Add phone number",
        "geoModifier": "Geomodifier",
        "addFeatureMessage": "Add feature message",
        "healthcareFacility": "Healthcare facility",
        "healthcareProfessional": "Healthcare professional",
        "hotel": "Hotel",
        "restaurant": "Restaurant",
        "listingDirectories": "Listing Directories",
        "listingDirectoriesDescription": "Publish and sync your location across 200+ directories.",
        "findOnGoogle": "Find on Google",
        "enterManually": "Enter manually",
        "googleAccountRequired": "Connect your Google account in the Integration settings to continue",
        "facebookAccountRequired": "Connect your Facebook account in the Integration settings to continue",
        "tiktokAccountRequired": "Connect your TikTok account in the Integration settings to continue",
        "xAccountRequired": "Connect your X account in the Integration settings to continue",
        "whatsappAccountRequired": "Connect your WhatsApp account in the Integration settings to continue",
        "createGoogleProfileTitle": "Create profile on Google",
        "createGoogleProfileDescription": "Choose which Google account and location group this listing should be created under.",
        "googleAccount": "Google account",
        "googleLocationGroup": "Location group",
        "selectAccountToLink": "Choose which connected account this location should publish to.",
        "account": "Account",
        "linkedinAccountRequired": "Connect your LinkedIn account in the Integration settings to continue",
        "linkedinPersonal": "Personal profile",
        "linkedinPage": "Company Page",
        "connectedToLocation": "Connected to {{location}}",
        "localDirectories": "Local Directories",
        "addLocalDirectories": "Add Local Directories",
        "cancelLocalDirectories": "Cancel Local Directories",
        "cancelLocalDirectoriesDescription": "Publishing continues until the end of the period you've paid for, then this location's listings are removed. No refunds are issued.",
        "directoriesValueCopy": "Publish this location to 200+ directories — from Apple Maps and Bing to TripAdvisor and Yelp — and keep hours, photos and details in sync automatically. Consistent data everywhere is what local search and AI answers like ChatGPT rely on, so you get found first and win more customers.",
        "directoriesPromoTitle": "Get found on 200+ local directories",
        "directoriesPromoDescription": "Publish {{location}} to 200+ directories — Apple Maps, Bing, TripAdvisor, Yelp and more — with details always in sync. Get found first in local search and AI answers like ChatGPT.",
        "seeAllDirectories": "See all directories",
        "perLocation": "per location",
        "directoriesMinimumTermNotice": "Can be cancelled after 3 months.",
        "chargedTodayProrated": "Charged today (prorated)",
        "thenFrom": "Then from {{date}}",
        "addForToday": "Add for {{amount}} today",
        "subscribeAndAddLocation": "Subscribe & add this location",
        "directoriesRequiresSubscription": "Local Directories requires an active subscription. Subscribe to your plan and add this location in one step.",
        "directoriesSinceCancellableAfter": "Publishing since {{since}} · cancellable after {{cancellableAfter}}",
        "directoriesCancellableAfter": "Cancellable after {{date}}",
        "directoriesEndsOn": "Publishing until {{date}}",
        "directoriesIncludedInPlan": "Included in your plan",
        "viewListings": "View Directories",
        "directoriesAddedMsg": "Local Directories added. Publishing has started.",
        "directoriesCancelledMsg": "Local Directories cancelled. Publishing continues until the end of your paid period."
    },
    "ScorePanel": {
        "recommendations": "Recommendations",
        "allDone": "Everything that counts towards the score is filled in",
        "suggest": "Suggest",
        "write": "Write",
        "dismiss": "Dismiss",
        "replace": "Replace",
        "undo": "Undo",
        "waitForAi": "Wait for Pulse AI to finish",
        "thinking": "Pulse AI is working on it…",
        "failed": "Suggestions could not be generated. Try again.",
        "noSuggestions": "Pulse AI has no suggestions for this location.",
        "reviewBeforeSave": "Review it in the form. Nothing is saved until you select Save.",
        "aiServices": "Pulse AI · based on your categories and description",
        "aiCategories": "Pulse AI · based on your business details",
        "aiSpecialHours": "Pulse AI · public holidays in {{country}}",
        "aiDescription": "Pulse AI · suggested description",
        "specialHoursNote": "Dates are added as Closed. Switch a date to Open and set its hours if you trade that day.",
        "addServices_zero": "Add services",
        "addServices_one": "Add {{count}} service",
        "addServices_other": "Add {{count}} services",
        "addCategories_zero": "Add categories",
        "addCategories_one": "Add {{count}} category",
        "addCategories_other": "Add {{count}} categories",
        "addDates_zero": "Add dates",
        "addDates_one": "Add {{count}} date",
        "addDates_other": "Add {{count}} dates",
        "drafted": {
            "shortDescription": "Short description drafted",
            "mediumDescription": "Medium description drafted",
            "longDescription": "Long description drafted"
        },
        "rec": {
            "locationName": "Add the location name",
            "practitioner": "Complete practitioner details",
            "certifications": "Add a certification",
            "phone": "Add a phone number",
            "email": "Add an email",
            "website": "Add a website",
            "address": "Complete the address",
            "workingHours": "Set business hours",
            "specialHours": "Add special hours",
            "shortDescription": "Add a short description",
            "mediumDescription": "Add a medium description",
            "longDescriptionAdd": "Add a long description",
            "longDescriptionExtend": "Extend the long description",
            "openingDate": "Add the opening date",
            "engagement": "Add a featured message",
            "categoriesAdd": "Add a category",
            "categoriesMore": "Add another category",
            "servicesAdd": "Add services",
            "servicesMore": "Add more services",
            "paymentMethods": "Select payment methods",
            "logo": "Upload a logo",
            "cover": "Upload a cover photo",
            "socialAdd": "Add a social link",
            "socialMore": "Add another social link"
        }
    },
    "SettingsChannels": {
        "historyImportRunning": "Importing past chats…",
        "historyImportCompleted": "Past chats imported",
        "historyImportDeclined": "Past chats not shared",
        "historyImportFailed": "Past chats or contacts couldn't be imported",
        "headerTitle": "Manage your channels",
        "headerSubtitle": "Connect all your communication channels to deliver a consistent customer experience from a single dashboard",
        "firstStepTitle": "Add new channel",
        "firstStepSubtitle": "Select what type of channel you want to add",
        "createChannelTitle": "Add new {{channelType}} channel",
        "editChannelTitle": "Edit {{channelType}} channel",
        "editChannelSubtitle": "Deliver instant support to your customers with {{channelType}} integration",
        "linkChannelToLocation": "Link this channel to a location or brand",
        "channelName": "Channel name",
        "senderId": "Sender ID",
        "provider": "Provider",
        "accountSid": "Account SID",
        "authToken": "Auth token",
        "apiToken": "HTTP API Token",
        "customGateway": "Custom gateway",
        "whatsAppNumber": "WhatsApp number",
        "senderIdNotice": "Sender ID identifies the sender of an SMS message. It may be up to 11 characters including upper- and lower-case letters, the digits 0 through 9, and space.",
        "isNewWhatsAppAcc": "New WhatsApp account?",
        "whatsAppSuccess": "WhatsApp successfully connected!",
        "whatsAppFail": "Number already exists under this account",
        "whatsAppTooltip": "Enable this option if your WhatsApp number was registered fewer than 30 days ago to reduce the likelihood of blocking it when sending automatic bulk messages. If enabled, Pluspoint sets a limit for messages sent through this channel to 2 requests per day. This limit is gradually increased by 1.5 times every day (eg 2, 3, 5, 7, 10, etc).",
        "whatsAppInstruction1": "1. Open WhatsApp on the phone with provided number",
        "whatsAppInstruction2": "2. Tap <strong>{{settings}}</strong> and then tap on <strong>{{qrIcon}}</strong>",
        "qrIcon": "QR icon",
        "whatsAppInstruction3": "3. Tap on <strong>{{scan}}</strong> and point your phone to this screen",
        "scan": "Scan",
        "pending": "Pending",
        "welcomeTagline": "Welcome message",
        "businessHoursSwitch": "Enable business hours",
        "offlineMessage": "Offline message",
        "widgetPosition": "Live-chat widget position",
        "widgetOffsetX": "Horizontal offset (px)",
        "widgetOffsetY": "Vertical offset (px)",
        "addCodeBelow": "Add the code below to the head section of your website’s HTML.",
        "messagesTab": "Messages",
        "contactDetailsHint": "Asked in the chat after the visitor's first message. At least one of email or phone must be required.",
        "assignLocationSwitch": "Assign conversations to a location",
        "assignLocationHint": "Each conversation is assigned to a location. When more than one location is listed, visitors are asked to choose the location they are contacting.",
        "allLocationsCount": "All locations ({{number}})",
        "selectedLocations": "Selected locations",
        "reachVisitorsTitle": "Reach visitors who left",
        "missedRepliesSwitch": "Notify about missed replies",
        "missedRepliesHint": "When an agent replies after the visitor closed the page, they get a short note with a link back into the chat.",
        "followUpRequiresContact": "Requires a required email or phone field",
        "followUpChannelCleared": "The selected channel no longer matches the contact fields; pick another",
        "followUpChannelUnavailable": "The follow-up channel is disconnected or deleted; pick another",
        "followUpChannelOtherTeam": "A channel from another team",
        "welcomeButtons": "Buttons",
        "welcomeButton": "Button {{number}}",
        "addButton": "Add button",
        "welcomePopupSwitch": "Show the welcome message beside the chat button automatically",
        "welcomePopupHint": "Appears a few seconds after the page loads, once per visitor. On phones, or when off, visitors see it when they open the chat.",
        "showOfflineMessage": "Show offline message",
        "offlineHoursHint": "Posted into the chat outside the hours below.",
        "websiteWidget": "Website widget",
        "chatLink": "Chat link",
        "chatLinkHint": "Opens this chat on a hosted page. Share it as a link or a QR code where the widget cannot be installed: menus, receipts, email signatures, social profiles.",
        "chatLinkParams": "Add ?locationId= with a location ID to skip the location question, ?language= with a language code to open the chat in that language, or ?start= with a message to prefill the visitor’s first message.",
        "allowedSites": "Allowed sites",
        "allowedSitesHint": "Domains the widget may appear on, subdomains included. Leave the list empty to allow any site. Your microsites and the chat link are always allowed.",
        "allowedSiteInvalid": "Enter a domain such as example.com",
        "signedInCustomers": "Signed-in customers",
        "signingSecretHint": "Sign the customer details on your server with this secret so customers who are signed in on your site skip the form.",
        "signingSecret": "Signing secret",
        "replaceSecretTitle": "Replace the signing secret?",
        "replaceSecretBody": "Details signed with the current secret stop being accepted at once. Update your website with the new secret.",
        "followUpWarning": "Warning",
        "logoUrl": "Logo URL",
        "smtpHost": "SMTP Host",
        "smtpPort": "SMTP Port",
        "username": "Username",
        "encryption": "Encryption",
        "saveInstagramReplies": "Receive story mentions",
        "createNewChannel": "Create new channel",
        "enableIncomingEmail": "Receive emails in inbox (IMAP)",
        "enableIncomingEmailHint": "Receive and reply to customer emails directly from the inbox",
        "imapHost": "IMAP Host",
        "imapPort": "IMAP Port",
        "imapUsername": "IMAP Username",
        "imapUsernamePlaceholder": "Leave empty to use SMTP username",
        "imapPassword": "IMAP Password",
        "imapPasswordPlaceholder": "Leave empty to use SMTP password",
        "signature": "Email Signature",
        "facebookPage": "Facebook page",
        "hostedEmailSubtitle": "Send campaigns, surveys and Inbox replies from an address on your own domain.",
        "receiveEmailsInInbox": "Receive emails in Inbox",
        "forwardingAddress": "Forwarding address",
        "receiveRepliesHint": "Forward {{email}} to this address in your mail host. Replies then appear in Inbox and you answer them from here.",
        "fromNameHint": "Shown as the sender name",
        "emailAddress": "Email address",
        "emailAddressLocked": "The address cannot be changed after the channel is created",
        "returnPathSubdomain": "Return-Path subdomain",
        "customReturnPath": "Use a custom Return-Path subdomain",
        "customReturnPathHint": "Bounced emails come back through this subdomain. Change the default only if your domain already uses it.",
        "returnPathSubdomainReused": "{{domain}} is already connected. The new address shares its DNS records and Return-Path subdomain.",
        "returnPathSubdomainInvalid": "Use letters, digits and hyphens only",
        "verifyDomainTitle": "Verify {{domain}}",
        "verifyDomainSubtitle": "Add these records at your DNS provider. The channel becomes available once all of them are verified.",
        "dnsRecordsHint": "These two DNS records verify that the domain is yours and let mailbox providers trust your emails. The TXT record signs your messages; the CNAME record handles bounces.",
        "dnsPropagationNote": "Note: it can take up to 48 hours for DNS changes to propagate.",
        "showDnsRecords": "Show DNS records",
        "hideDnsRecords": "Hide DNS records",
        "recordVerified": "Verified",
        "statusSuspended": "Suspended",
        "domainSuspended": "Sending from this domain is suspended. Contact support to resume.",
        "ringCentralAccount": "RingCentral account",
        "ringCentralNumber": "RingCentral number",
        "ringCentralNoNumbers": "This RingCentral user has no number that can send SMS",
        "ringCentralNumbersInUse": "Every number on this RingCentral account is already used by another channel",
        "ringCentralDisconnected": "The RingCentral account behind this channel is disconnected. Reconnect it in <0>{{link}}</0> to resume sending.",
        "ringCentralIntegrations": "Integrations"
    },
    "SettingsUsers": {
        "addedOn": "Added on",
        "lastLogin": "Last logged in",
        "generalInfo": "General info",
        "editUser": "Edit user",
        "accessLevel": "Access level",
        "owner": "Owner",
        "global": "Global",
        "role": "Role",
        "superAdmin": "Super admin",
        "admin": "Admin",
        "user": "User",
        "permissions": "Permissions",
        "permissionsDescription": "Select a role: Super Administrators can change global settings and manage account integrations. Administrators can configure locations, surveys, templates, and campaigns, typically for department heads or business owners. Users manage daily business activities, suitable for operational staff.",
        "accessDescription": "Select an access level: Global gives access to the entire organization, Brand allows access to a selected group of locations, and Location provides access to specific locations only.",
        "globalAccess": "Global access level",
        "brandAccess": "Brand-based access level",
        "locationAccess": "Location-based access level"
    },
    "SettingsTeams": {
        "createTeam": "Create team",
        "editTeam": "Edit team",
        "teamName": "Team name",
        "permissions": "Permissions",
        "permissionsDescription": "Control what each team can do. Restricted allows viewing and basic actions, while Full unlocks editing, creating, and managing within each module. Account Settings can also be set to None to hide settings entirely.",
        "restricted": "Restricted",
        "full": "Full",
        "none": "None",
        "noneTooltip": "No access — the feature is hidden for this team",
        "globalPermission": "Global",
        "scope": "Scope",
        "scopeDescription": "Define which locations this team can access. Global gives access to all locations, Brand limits access to locations within selected brands, and Location restricts access to specific locations only.",
        "scopeScopedOnlyNote": "Scope applies to scoped permissions only. Global permissions (Contacts, Account Settings) always cover the whole account.",
        "members": "Members",
        "membersDescription": "Select users to add to this team. Members can be changed later.",
        "addMember": "Add member",
        "enabledPermissionsCount": "{{count}} permissions",
        "messagingRestricted": "View, Reply, Reassign, Resolve/Re-open, Export, Analytics",
        "messagingFull": "AI Agents, Knowledge base",
        "accountSettings": "Account Settings",
        "tooltipRestricted": "Restricted",
        "tooltipFull": "Full",
        "contactsRestricted": "View all contacts in the account",
        "contactsFull": "Create, Edit, Delete, Bulk actions, Import, Export",
        "locationsRestricted": "View locations and profiles, Upload/Delete media, Export CSV",
        "locationsFull": "Add/Import locations, Edit, Delete, Bulk edit, Export/Import, Sync, Analytics",
        "reviewsRestricted": "View, Reply to reviews, Use reply templates, Analytics, Widgets",
        "reviewsFull": "Manage auto-replies and reply templates",
        "postsRestricted": "View posts, Analytics",
        "postsFull": "Create, Edit, Delete, Schedule posts",
        "micrositesRestricted": "View web pages",
        "micrositesFull": "Create, Edit, Delete web pages",
        "surveysRestricted": "View responses, Conversations, Tickets, View templates",
        "surveysFull": "Manage survey templates",
        "campaignsRestricted": "View campaigns",
        "campaignsFull": "Create, Edit, Delete campaigns",
        "couponsRestricted": "View coupons",
        "couponsFull": "Create, Edit, Delete coupons",
        "settingsNoneTooltip": "Profile page only",
        "settingsRestrictedTooltip": "Users management: invite, edit, delete users",
        "settingsFullTooltip": "All settings: General, Billing, Brands, Users, Teams, Channels, Integrations"
    },
    "SettingsBrands": {
        "title": "Organize your locations with brands",
        "subtitle": "Easily group locations under a single brand for centralized control of messaging channels, review platforms, campaigns, and surveys. Simplify your operations and maintain consistency across all locations.",
        "editBrand": "Edit brand",
        "shared": "Shared",
        "gradient": "Gradient",
        "solid": "Solid",
        "sharp": "Sharp",
        "softlyRounded": "Softly rounded",
        "rounded": "Rounded",
        "fontColor": "Font color",
        "automaticallyAssignBrand": "Automatically assign brand to new locations",
        "brandIsAlreadyAssigned": "A default brand is already set for this account",
        "createNewBrand": "Create new brand",
        "previewDisclaimer": "This is only a demonstration of how your brand appears to customers."
    },
    "ShowcaseWidgets": {
        "title": "Customer reviews",
        "subtitle": "Showcase positive customer reviews on your website pages using our widgets.",
        "popup": "Pop-up",
        "grid": "Grid",
        "popupWidget": "Pop-up widget",
        "gridWidget": "Grid widget",
        "reviewsSorting": "Reviews sorting",
        "random": "Randomly",
        "recent": "Most recent",
        "reviewsToShow": "Total reviews to show",
        "reviewsMode": "Which reviews to show",
        "topRatedReviews": "5-star reviews with comments",
        "featuredReviews": "Featured reviews",
        "noFeaturedReviews": "No featured reviews yet. Mark reviews as featured on the Reviews page",
        "widgetPosition": "Widget position",
        "widgetCode": "Widget code",
        "addCodeSubtitle": "Add the code below to the HTML of your website where you’d like display the widget."
    },
    "Sidebar": {
        "bookmarks": "Bookmarks",
        "addBookmark": "Add to bookmarks",
        "removeBookmark": "Remove from bookmarks",
        "home": "Home",
        "responses": "All responses",
        "templates": "Templates",
        "surveys": "Surveys",
        "surveysQrOnly": "QR Codes",
        "analytics": "Analytics",
        "analyticsConversion": "Conversion",
        "analyticsNpsOverview": "NPS Overview",
        "analyticsSurveyInsights": "Survey Insights",
        "analyticsSurveys": "NPS and Surveys",
        "analyticsConversations": "Conversations",
        "analyticsPresence": "Presence",
        "analyticsSocialPosts": "Social posts",
        "performance": "Performance",
        "insights": "Insights",
        "reviews": "Reviews",
        "reviewsManage": "All reviews",
        "reviewsTemplates": "Reply templates",
        "reviewsAutoreplies": "Auto-replies",
        "reviewsAutomation": "Automation",
        "microsites": "Microsites",
        "messaging": "Messaging",
        "messagingInbox": "Inbox",
        "reviewsWidgets": "Website widgets",
        "social": "Social",
        "socialPosts": "Posts",
        "profile": "Profile",
        "helpCenter": "Help Center",
        "logout": "Log out",
        "switchAccount": "Switch account",
        "accountMenu": "Account menu",
        "ordersIfood": "Orders",
        "campaigns": "Campaigns",
        "campaignsAutomated": "Automated",
        "campaignsOneTime": "One-time",
        "contacts": "Contacts",
        "presence": "Presence",
        "presenceProfiles": "Profiles",
        "presenceMedia": "Photos and videos",
        "locations": "Locations",
        "locationsManage": "Manage locations",
        "locationsProfiles": "Profiles",
        "locationsMedia": "Photos & Videos",
        "visibilityScanner": "Visibility Scanner",
        "pulseAI": "Pulse AI",
        "knowledgeBase": "Knowledge Base",
        "agents": "Agents",
        "referral": "Referral program",
        "coupons": "Coupons",
        "expand": "Expand",
        "collapse": "Collapse",
        "webPages": "Web pages",
        "menus": "Menus",
        "forms": "Forms",
        "campaignsLibrary": "Library"
    },
    "SignupPage": {
        "title": "Create a free account",
        "description": "Start managing your listings, reviews, and customer conversations in one place.",
        "alreadyRegistered": "Already have an account? <0>{{link}}</0>",
        "logIn": "Log In",
        "terms": "Terms of Use,",
        "privacy": "Privacy Policy",
        "dpa": "Data Processing Agreement",
        "termsConditions": "By using Pluspoint you agree to <0>{{terms}}</0> <1>{{privacy}}</1> and <2>{{dpa}}</2>",
        "confirmationTitle": "Check your mailbox",
        "confirmationDescription": "We have sent a confirmation email for your response. Please ensure to check your spam box in case you can't find it in your inbox.",
        "returnToHomepage": "Return to homepage",
        "signupWithGoogle": "Sign up with Google",
        "signupWithGoogleCaption": "Make sure to select all checkboxes to get full functionality",
        "or": " or "
    },
    "Table": {
        "allOnPageSelected": "All {{selected}} {{entity}} on this page are selected.",
        "selectAll": " Select all {{data}} {{entity}}",
        "allDataSelected": "All {{data}} {{entity}} selected.",
        "clearSelection": " Clear selection.",
        "moreThan": "more than",
        "of": "of",
        "rowsPerPage": "Rows per page"
    },
    "FeedbackToolbar": {
        "reviewsTicketToggle": "Show only feedback without tickets",
        "createTicket": "Create ticket",
        "viewTicket": "View ticket",
        "ticketAssignedTo": "Ticket assigned to:",
        "ticketStatus": "Ticket status:",
        "completed": "Completed",
        "empty": "Empty",
        "price": "Price",
        "quality": "Quality",
        "cleanliness": "Cleanliness",
        "communication": "Communication",
        "ticketDescription": "Ticket description"
    },
    "AuthLayout": {
        "title": "Take control of your <0>{{reputation}}</0>",
        "onlineReputation": "online reputation",
        "block1Title": "Boost online reviews",
        "block1Description": "Turn happy customers into promoters with automated review requests.",
        "block2Title": "Save time",
        "block2Description": "Respond to reviews, messages, and schedule posts from one dashboard.",
        "block3Title": "Grow online presence",
        "block3Description": "Drive more traffic by publishing your business on 200+ platforms."
    },
    "validation": {
        "minPasswordLength": "Your password must be at least 8 characters long",
        "wrongPasswordFormat": "Your password must contain numbers and letters",
        "confirmPasswordMatch": "Passwords don't match, please try again",
        "minLength4": "This field must be at least 4 characters long",
        "minLength8": "This field must be at least 8 characters long",
        "wrongEmailFormat": "Please enter a valid email address",
        "wrongFile": "Incorrect file format",
        "maxLength": "This field should be up to {{count}} characters",
        "trackingTagSlug": "Use lower-case letters, digits and hyphens",
        "trackingTagPaidMedium": "Analytics would count this medium as paid traffic",
        "trackingTagShoppingCampaign": "Analytics would count this campaign as shopping traffic",
        "numberRange": "Enter a value between {{min}} and {{max}}",
        "descriptionContainsUrl": "Links are not allowed in the description",
        "hexFormat": "Must be in HEX format",
        "onlyAlphanumericSpace": "Should only contain letters, numbers, spaces",
        "onlyNumbers": "Should only contain numbers",
        "invalidURL": "Invalid URL",
        "takenURL": "Unavailable",
        "required": "This field is required",
        "wrongPhoneFormat": "Should be in an international format",
        "specialHoursNeedBusinessHours": "Remove the special dates or switch business hours on",
        "specialHoursDuplicateDate": "This date is already listed. Keep one entry per date",
        "specialHoursReversedRange": "A time range must end after it starts",
        "duplicatePhone": "This number is already listed",
        "timeRangeExceeded": "Time range exceeded",
        "completeAllFields": "Complete the required fields to continue",
        "platformWithoutDirectCompany": "Each selected platform needs at least one directly-connected location",
        "unsupportedPlaceholders": "Unsupported placeholder(s): {{tokens}}",
        "dateOfBirthOutOfRange": "Enter a date from 1900 onwards that is not in the future"
    },
    "VerifyEmail": {
        "message": "Your email is not verified. We've sent the verification instructions to {{email}}. If you can't find the verification email please check the spam folder. You can also resend the email by clicking on <1>{{link}}</1>.",
        "link": "RESEND VERIFICATION EMAIL",
        "resendSuccess": "Email has been successfully resent",
        "resendFail": "Couldn't resend email"
    },
    "InboxPage": {
        "sentFromWhatsAppBusinessApp": "WhatsApp Business app",
        "sentFromWhatsAppApp": "WhatsApp app",
        "sentFromMetaBusinessSuite": "Meta Business Suite",
        "sentFromExternalApp": "External app",
        "unsupportedMessage": "This message can't be shown here. Check the WhatsApp Business app.",
        "mediaNotImported": "Photo or file not imported",
        "viewFullContact": "View full contact",
        "conversationsCount_one": "{{count}} conversation",
        "conversationsCount_other": "{{count}} conversations",
        "viewDetails": "View details",
        "createdAt": "Created",
        "resolvedAt": "Resolved",
        "pulseAgent": "Pulse",
        "views": "Views",
        "myConversations": "My conversations",
        "allConversations": "All conversations",
        "moveToTeam": "Move to team",
        "moveToTeamTitle": "Move to another team",
        "moveToTeamDescription": "The conversation and its full history move with it. The other team is notified.",
        "moveToTeamAssigneeKept": "{{name}} is a member of {{team}} and will stay assigned.",
        "moveToTeamAssigneeCleared": "{{name}} isn't a member of {{team}}. The conversation will be unassigned and placed in that team's queue.",
        "internalNoteOptional": "Internal note (optional)",
        "internalNote": "Internal note",
        "teamChangedBy": "{{date}} — {{name}} moved this conversation from {{fromTeam}} to {{toTeam}}",
        "teamChangedAuto": "{{date}} — Conversation was moved from {{fromTeam}} to {{toTeam}} following a channel team change",
        "deletedTeam": "a deleted team",
        "conversationAssignedToUser": "This conversation is assigned to {{name}}. You can join it to interact with the customer directly.",
        "movedToTeam": "Conversation moved to {{team}}",
        "open": "Open",
        "resolved": "Resolved",
        "viewContact": "View contact",
        "messageLabel": "Type your message here",
        "noConversations": "There are no conversations.",
        "noConversationsSelected": "Please select a conversation from the left pane.",
        "resolvedBy": "{{date}} — Resolved by {{name}}",
        "reopenedBy": "{{date}} — Reopened by {{name}}",
        "conversationStarted": "{{date}} — Conversation started",
        "download": "Download",
        "resend": "Resend",
        "emptyChannelsTitle": "All your conversations in one place",
        "emptyChannelsSubtitle": "See all your customer conversations in one dashboard. Connect multiple channels — from your website’s live chat to Facebook, Instagram, or WhatsApp.",
        "emptyChannelsButton": "Connect channels",
        "storyNotAvailable": "Story no longer available",
        "showQuotedText": "Show quoted text",
        "hideQuotedText": "Hide quoted text",
        "mine": "Mine",
        "unassigned": "Unassigned",
        "archivedConversation": "This conversation is from a removed channel. You cannot reopen it or receive new messages.",
        "importedConversation": "This conversation was imported from the WhatsApp Business app. You cannot reopen it; start a new conversation to message the contact.",
        "disconnectedChannel": "This conversation is from a disconnected channel. Please reconnect the channel in <0>{{link}}</0>.",
        "settings": "settings",
        "liveChatVisitorUnreachable": "This visitor cannot be reached after they leave. Pick a follow-up channel in <0>{{link}}</0>.",
        "closedConversation": "This conversation is resolved. You can re-open it to continue messaging the contact.",
        "whatsApp24HoursWindow": "WhatsApp allows free-text replies only within 24 hours of the customer's last message. To reach them, <0>{{link}}</0>. You can reply freely once they write back.",
        "useApprovedMessage": "use an approved message template",
        "messagingWindowClosed": "Meta no longer accepts replies in this conversation. You can reply again once the customer writes back.",
        "activityNewestFirst": "Last activity: Newest first",
        "activityOldestFirst": "Last activity: Oldest first",
        "createdAtNewestFirst": "Created at: Newest first",
        "createdAtOldestFirst": "Created at: Oldest first",
        "backToAllConversations": "Back to all conversations",
        "messageDeleted": "Deleted",
        "conversationSelected_one": "{{count}} conversation selected",
        "conversationSelected_other": "{{count}} conversations selected",
        "exportInProgress": "Export in progress. You’ll receive an email when your file is ready",
        "editConversations": "Edit conversations",
        "selectProperty": "Select property",
        "conversationAssignedOnPulse": "This conversation is currently assigned to Pulse. You can join it to interact with the customer directly.",
        "replyTab": "Reply",
        "noteTab": "Note",
        "notePlaceholder": "Add an internal note…",
        "noteVisibilityHint": "Never visible to the customer",
        "noteSnippet": "Note: {{text}}",
        "collaborators": "Collaborators",
        "addCollaborator": "Add",
        "tags": "Tags",
        "addTag": "Add",
        "createNewTag": "Create",
        "tagNamePlaceholder": "New tag name",
        "deleteTagTitle": "Delete tag?",
        "deleteTagDescription": "\"{{name}}\" will be deleted for the entire account and removed from all conversations.",
        "editTagTitle": "Edit tag",
        "tagColor": "Color",
        "keepMeAsCollaborator": "Keep me as a collaborator",
        "collaborating": "Collaborating",
        "collaboratorReadOnly": "You follow this conversation as a collaborator — use internal notes to contribute",
        "bulkEditPartial": "Updated {{updated}} of {{total}} conversations — collaborator-only conversations stay unchanged",
        "bulkEditUpdatedCount": "Updated {{updated}} of {{total}} conversations"
    },
    "SocialPosts": {
        "title": "Create, customize, and schedule posts across platforms",
        "subtitle": "Plan, customize, and schedule social posts across every connected location and platform from one place.",
        "editPost": "Edit post",
        "viewPost": "Post details",
        "tableView": "Table",
        "calendarView": "Calendar",
        "moreCount": "+{{count}} more",
        "rescheduleSuccess": "Post rescheduled",
        "rescheduleFail": "Couldn't reschedule the post",
        "book": "Book",
        "orderOnline": "Order online",
        "buy": "Buy",
        "signUp": "Sign up",
        "callNow": "Call now",
        "imageFormat": "Images: Format: JPG or PNG. Size: 10KB to 10MB. Larger images are optimized automatically.",
        "videoFormatDynamic": "Videos: Format: MP4. Resolution: up to {{maxResolution}}. Size: up to {{maxSize}}. Duration: {{minDuration}} to {{maxDuration}}.",
        "videoConstrainedBy": "{{platform}} sets this limit.",
        "noMediaPreview": "Upload images or a video to see a preview here",
        "content": "Content",
        "contentDescription": "Start with a shared post, then adjust content, media, and options for each platform.",
        "allPlatforms": "All platforms",
        "customizeFor": "Customize for {{platform}}",
        "media": "Media",
        "customized": "Customized",
        "messageRequired": "Add a message",
        "tiktokAutoAddMusic": "Automatically add music",
        "tiktokAutoAddMusicHint": "TikTok adds a recommended sound to image posts. You can change it later in the TikTok app.",
        "videoTooLongForCreator": "Longer than {{handle}} allows on TikTok (max {{limit}})",
        "tiktok": {
            "loadingCreatorInfo": "Loading TikTok account settings…",
            "cannotPostNow": "TikTok isn't accepting posts from {{handle}} right now. Try again later.",
            "creatorInfoFailed": "Couldn't load TikTok account settings.",
            "retry": "Retry",
            "privacy": "Who can view this post",
            "privacyHint": "Options come from the connected accounts.",
            "privacyLevels": {
                "PUBLIC_TO_EVERYONE": "Everyone",
                "MUTUAL_FOLLOW_FRIENDS": "Friends",
                "FOLLOWER_OF_CREATOR": "Followers",
                "SELF_ONLY": "Only me"
            },
            "privacyNoCommonOption": "These TikTok accounts share no privacy option. Remove {{handle}} or schedule it separately.",
            "privacyNoCommonOptionAny": "These TikTok accounts share no privacy option. Schedule them separately.",
            "privacyChooseAgain": "Choose who can view this post.",
            "interactions": "Allow viewers to",
            "allowComment": "Comment",
            "allowDuet": "Duet",
            "allowStitch": "Stitch",
            "interactionDisabled": "Disabled in {{handle}}'s TikTok settings",
            "interactionDisabledForSome": "{{handle}} has this turned off in TikTok, so their post publishes without it.",
            "commercial": "Disclose commercial content",
            "commercialHint": "Turn on if this post promotes your business, a brand, a product or a service.",
            "yourBrand": "Your brand",
            "brandedContent": "Branded content",
            "labelPromotional": "Your {{media}} will be labeled as 'Promotional content'",
            "labelPaidPartnership": "Your {{media}} will be labeled as 'Paid partnership'",
            "mediaWordVideo": "video",
            "mediaWordPhoto": "photo",
            "commercialIncomplete": "You need to indicate if your content promotes yourself, a third party, or both.",
            "brandedNotPrivate": "Branded content visibility cannot be set to private.",
            "consent": "By posting, you agree to TikTok's <musicLink>Music Usage Confirmation</musicLink>",
            "consentBranded": "By posting, you agree to TikTok's <bcLink>Branded Content Policy</bcLink> and <musicLink>Music Usage Confirmation</musicLink>",
            "processingNote": "TikTok can take a few minutes to show a post on the profile after it is published.",
            "publishingTooltip": "TikTok is processing this post. It can take a few minutes to appear on the profile.",
            "unauditedBanner": "This environment can only publish private TikTok posts.",
            "noTikTokLocation": "Select a location with a connected TikTok account.",
            "noCreators": "None of the selected locations can post to TikTok right now.",
            "reconnectAccount": "Reconnect {{handle}} in Settings, Integrations before scheduling.",
            "thisAccount": "this TikTok account",
            "chooseAccount": "Choose which TikTok account posts for this location on the location's profile."
        },
        "messageTooLong": "Message exceeds the {{count}} character limit for this platform",
        "mediaRequired": "This platform requires at least one image or video",
        "videoTooLarge": "Video exceeds the {{limit}} size limit for this platform",
        "videoTooLong": "Video exceeds the {{limit}} duration limit for this platform",
        "videoTooSmall": "Video is below the {{limit}} minimum size for this platform",
        "videoTooLargeSummary": "Video too large for: {{platforms}}",
        "videoTooLongSummary": "Video too long for: {{platforms}}",
        "videoTooSmallSummary": "Video too small for: {{platforms}}",
        "checkingVideoLength": "Checking video length…",
        "mediaRules": {
            "google": "One image max. Video not supported.",
            "facebook": "One video max, or up to 10 images (not mixed).",
            "instagram": "Up to 10 images or videos. Media required.",
            "tiktok": "One video max, or up to 35 images (not mixed). Some TikTok accounts allow shorter videos than shown.",
            "x": "One video max, or up to 4 images (not mixed).",
            "linkedin": "One video max, or up to 20 images (not mixed).",
            "facebookStory": "Exactly one image or video. 9:16 recommended.",
            "instagramStory": "Exactly one image or video. 9:16 recommended. Images are converted to JPEG."
        },
        "retry": "Retry",
        "openPublishedPost": "View post",
        "storyMediaOnlyNotice": "Stories publish media only — text won't appear on the story.",
        "storyAspectWarning": "This media isn't 9:16 — {{platform}} will crop it to fit.",
        "storyExpiry": "View story (stories expire 24 hours after publishing)",
        "storyExpired": "This story has expired — the link may no longer work",
        "queued": "Queued",
        "removedExternally": "Removed on platform",
        "cancelPost": "Cancel post",
        "cancelPostTitle": "Cancel this post?",
        "cancelPostDescription": "This post won't be published.",
        "deletePostTitle": "Delete this post?",
        "deletePostDescription": "This removes the published post from the platform. This can't be undone.",
        "preview": {
            "emptyHint": "Select platforms and locations, then add a message or media to preview your post",
            "seeMore": "See more",
            "like": "Like",
            "comment": "Comment",
            "share": "Share",
            "more": "more",
            "likesPlaceholder": "Liked by your followers",
            "tiktokSound": "Original sound",
            "storyHint": "9:16 preview · media only"
        },
        "videoTooWide": "Video is wider than the {{width}}×{{height}} maximum for this platform",
        "videoTooWideSummary": "Video resolution too high for: {{platforms}}"
    },
    "PostDynamicVariables": {
        "title": "Dynamic variables"
    },
    "UpdateLocations": {
        "title": "Import locations",
        "subtitle": "Update or create multiple locations at once using a CSV file.",
        "list1Title": "Download template",
        "list1Description": "Download the template with your existing locations",
        "list2Title": "Upload file",
        "list2Description": "Upload your file. Fill in the Location ID to update an existing location, or leave it empty to create a new one.",
        "locationsToUpdate": "Locations to update",
        "locationsToAdd": "Locations to add",
        "dataVerificationDescription": "Review the parsed locations. \"New\" rows will create a new location; \"Update\" rows will update an existing one.",
        "showAddress": "Show address",
        "featuredMessage": "Featured message",
        "featuredMessageUrl": "Featured message URL",
        "showHours": "Show hours",
        "importButton": "Import {{amount}} location(s)",
        "quotaExceeded": "Adding {{count}} new location(s) exceeds your limit of {{available}}."
    },
    "ImportValidationTable": {
        "showErrorsOnly": "Show errors only",
        "showErrorsOnlyCount": "Show errors only ({{count}} item(s))"
    },
    "BulkEditLocations": {
        "notUpdated": "{{count}} of {{total}} locations were not updated:",
        "title": "Bulk edit locations",
        "subtitle": "Edit multiple locations at once. Changes will apply to all selected locations.",
        "applyToLocations": "Apply to {{count}} location(s)",
        "services": "Services",
        "socialLinkPlatform": "Social link: {{platform}}"
    },
    "AIAssistant": {
        "translate": "Translate",
        "english": "English",
        "spanish": "Spanish",
        "portuguese": "Portuguese",
        "french": "French",
        "german": "German",
        "italian": "Italian",
        "russian": "Russian",
        "ukrainian": "Ukrainian",
        "polish": "Polish",
        "changeTone": "Change tone",
        "professional": "Professional",
        "friendly": "Friendly",
        "fixGrammar": "Fix spelling & grammar",
        "makeShoter": "Make shorter",
        "makeLonger": "Make longer",
        "writeResponse": "Write response",
        "writeTemplate": "Write template",
        "writePost": "Write post",
        "optimizeForPlatform": "Optimize for {{platform}}",
        "writeCampaign": "Write campaign",
        "writeReply": "Write reply",
        "writeDescription": "Write description"
    },
    "industry": {
        "Automotive": "Automotive",
        "BeautySpaAndSalon": "Beauty, Spa and Salon",
        "ClothingAndApparel": "Clothing and Apparel",
        "Education": "Education",
        "Entertainment": "Entertainment",
        "EventPlanningAndService": "Event Planning and Service",
        "FinanceAndBanking": "Finance and Banking",
        "FoodAndGrocery": "Food and Grocery",
        "Pharmacy": "Pharmacy",
        "PublicService": "Public Service",
        "HotelAndLodging": "Hotel and Lodging",
        "HealthcareAndDental": "Healthcare and Dental",
        "ProfessionalServices": "Professional Services",
        "ShoppingAndRetail": "Shopping and Retail",
        "TravelAndTransportation": "Travel and Transportation",
        "Restaurant": "Restaurant",
        "Veterinary": "Veterinary",
        "WellnessAndFitness": "Wellness and Fitness",
        "Other": "Other"
    },
    "themes": {
        "amenities": "Amenities",
        "atmosphere": "Atmosphere",
        "availability": "Availability",
        "billing": "Billing",
        "check-in/out": "Check-in/out",
        "checkout": "Checkout",
        "cleanliness": "Cleanliness",
        "communication": "Communication",
        "delivery": "Delivery",
        "experience": "Experience",
        "expertise": "Expertise",
        "facilities": "Facilities",
        "food": "Food",
        "location": "Location",
        "menu": "Menu",
        "noise": "Noise",
        "policies": "Policies",
        "pricing": "Pricing",
        "products": "Products",
        "quality": "Quality",
        "quality of care": "Quality of Care",
        "results": "Results",
        "rooms": "Rooms",
        "scheduling": "Scheduling",
        "service": "Service",
        "staff": "Staff",
        "transparency": "Transparency",
        "treatment": "Treatment",
        "value": "Value",
        "wait time": "Wait Time"
    },
    "ProfilesPage": {
        "title": "Boost your local SEO",
        "titleGoogle": "Enable Google to unlock full profile sync",
        "titleFreemium": "Upgrade to complete local visibility",
        "subtitleFreemium": "Get your locations published and synchronized across Apple Maps, Bing, ChatGPT, and 200+ major directories and navigation apps with Pluspoint Starter. Accurate listings improve local SEO and trust signals for AI assistants.",
        "subtitleGoogle": "Connect your Google account to keep location details, hours, photos, and updates fully synchronized. Without Google integration, profile data may be incomplete or outdated.",
        "subtitle": "Publish and synchronize your business profiles across 100+ directories, maps, and search platforms. Consistent listings increase your discoverability by customers, search engines, and AI assistants.",
        "profiles": "Profiles",
        "profileInformation": "Profile information",
        "syncStatus": "Sync status",
        "synced": "Synced",
        "syncStarted": "Sync started",
        "syncCompleted": "Sync completed",
        "lastSynced": "Last synced",
        "lastChecked": "Last checked",
        "details": "Details",
        "detailsConflictIntegration_one": "{{count}} field differs between Pluspoint and {{platform}}. Choose which values to keep to resolve the conflict.",
        "detailsConflictIntegration_other": "{{count}} fields differ between Pluspoint and {{platform}}. Choose which values to keep to resolve the conflict.",
        "detailsConflictScanner_one": "{{count}} field differs between Pluspoint and {{platform}}. Publish to update the profile.",
        "detailsConflictScanner_other": "{{count}} fields differ between Pluspoint and {{platform}}. Publish to update the profile.",
        "detailsNotFound": "Not listed on {{platform}}. Publish to make your business discoverable.",
        "detailsNotVerified": "{{platform}} profile is unverified. Verify to manage this listing.",
        "detailsDisconnected": "{{platform}} is disconnected. Reconnect to resume syncing.",
        "detailsSynced": "All key fields match the Pluspoint source of truth.",
        "detailsSyncedWithConflicts_one": "Profile is synced, but {{count}} field is ignored.",
        "detailsSyncedWithConflicts_other": "Profile is synced, but {{count}} fields are ignored.",
        "detailsDisabled": "Sync is turned off for this profile.",
        "resolveTitle": "Resolve conflicts",
        "resolveSubtitle": "Resolve listing conflicts by selecting the correct information",
        "syncSuccessMessage": "Sync in progress. You can continue using the system.",
        "noAddress": "No address",
        "field": "Field",
        "ignore": "Ignore",
        "openProfile": "Open profile",
        "usePlatformValue": "Use {{source}} value",
        "updatePlatformToMatch": "Update {{target}} to match {{source}}",
        "noChangesWillBeMade": "No changes will be made",
        "restrictedFieldHint": "{{source}} doesn't allow updating this field from Pluspoint. Update it in {{source}} directly or use the {{source}} value.",
        "noHoursToSendHint": "{{source}} can't show a page as having no opening hours, so there is nothing to send. Use the {{source}} value or ignore this field.",
        "noCoverToSendHint": "This location has no cover photo, so there is nothing to send. Use the {{source}} value or ignore this field.",
        "descriptionContainsUrlHint": "Google doesn't allow links in the business description. Remove the link to sync it.",
        "rejectedFieldHint": "{{source}} rejected this value ({{reasons}}). Fix it in Pluspoint and resolve again.",
        "socialLinkedElsewhere": "This social profile is already connected to another location. To use it across your locations, share it from the location it is connected to.",
        "titleScanner": "Your online presence overview",
        "subtitleScanner": "See where your business appears across directories. Publish to fix inaccuracies and get listed everywhere.",
        "notPublished": "Profile not found",
        "publishAction": "Publish",
        "upgradeToPublish": "Upgrade to publish your listings",
        "upgradeToPublishDescription": "Take control of your business information across 100+ directories by upgrading to a Starter plan.",
        "upgradeToPublishAll": "Upgrade to Publish All",
        "listingIssuesFound_one": "{{count}} listing issue needs attention",
        "listingIssuesFound_other": "{{count}} listing issues need attention",
        "listingIssuesDescription": "Missing listings and wrong contact details lower your local search ranking. Add Local Directories to a location to fix them and keep them in sync automatically.",
        "detailsNotFoundScanner": "Not listed on {{platform}} — upgrade to publish automatically"
    },
    "ProfilesMedia": {
        "exterior": "Exterior",
        "interior": "Interior",
        "product": "Product",
        "atWork": "At work",
        "foodAndDrink": "Food and Drink",
        "menu": "Menu",
        "commonArea": "Common area",
        "rooms": "Rooms",
        "teams": "Teams",
        "authorName": "Author",
        "profileName": "Profile",
        "locationsNames": "Locations",
        "categoryName": "Category",
        "viewCount": "Views",
        "createdAt": "Published on",
        "reportedAt": "Reported on",
        "viewContent": "View content",
        "uploadPhotos": "Upload photos",
        "photosFormat": "Format: JPG or PNG. Size: 10KB to 5MB. Minimum resolution: 720 px tall, 720 px wide."
    },
    "IntegrationRequired": {
        "title": "Integration required",
        "subtitleGoogle": "To enable this functionality, please connect your Pluspoint account to Google My Business",
        "subtitleCommon": "To enable this functionality, please connect your Pluspoint account to Google My Business or Facebook"
    },
    "KnowledgeBase": {
        "title": "Empower Pulse with your knowledge",
        "subtitle": "Equip Pulse with the answers it needs by adding your articles to its knowledge base. From FAQs to detailed guides, your content powers Pulse to deliver accurate, helpful responses to customers.",
        "editContent": "Edit content",
        "agents": "Agents",
        "limitToLocations": "Limit to specific locations",
        "items": "content items",
        "itemsSelected": "{{count}} content items selected",
        "faq": "FAQ",
        "document": "Document",
        "website": "Website",
        "addFaq": "Add FAQ",
        "addDocument": "Add document",
        "addWebsite": "Add website",
        "dropFileOr": "Drop a file here or",
        "browse": "browse",
        "acceptedFiles": "PDF, Word, Excel, CSV, PowerPoint, text, Markdown or image. Up to {{size}} {{metric}}, PDFs up to {{pages}} pages and sheets up to {{rows}} rows.",
        "processing": "Processing",
        "ready": "Ready",
        "failed": "Failed",
        "processingFailed": "Failed to process the file",
        "websitePlaceholder": "help.example.com or example.com/help",
        "invalidWebsite": "Enter a domain, with or without a path, such as help.example.com or example.com/help",
        "documentsAtLimit": "Documents are at their limit",
        "websitesAtLimit": "Websites are at their limit"
    },
    "Agents": {
        "title": "Shape Pulse to fit your needs",
        "subtitle": "Configure Pulse to align with your business needs. Set up AI agents for different channels and locations, each with tailored behavior—ensuring the right response for every customer interaction.",
        "editAgent": "Edit agent",
        "activateAgent": "Activate agent",
        "schedule": "Schedule",
        "answerOutsideBusinessHours": "Answer only outside business hours",
        "activeInBusinessHours": "Active · Business hours",
        "contactDetailsDescription": "Choose which contact details you would like Pulse to request from customers.",
        "autoCloseTitle": "Abandoned conversations",
        "autoCloseDescription": "Choose how Pulse should handle abandoned conversations after a specific period of inactivity.",
        "timeOfClientInactivity": "Time of client inactivity before action is applied:",
        "closeConversation": "Close conversation",
        "changeToUnassigned": "Change to Unassigned",
        "doNothing": "Do nothing",
        "conversationHandoff": "Conversation handoff",
        "conversationHandoffDescription": "Choose how Pulse should behave when it can't answer a question or when a customer asks for operator help.",
        "conversationHandoffSwitch": "Change to Unassigned",
        "handoffResponseTime": "Expected response time",
        "fewMinutes": "A few minutes",
        "withinHour": "Within an hour",
        "fewHours": "A few hours",
        "withinDay": "Within a day",
        "within2Days": "Within 2 days",
        "notTransferConversationSwitch": "Don’t transfer conversation",
        "channelTakenByAgent": "The channel is already assigned to another agent",
        "customInstructions": "Custom instructions",
        "customInstructionsDescription": "Add custom instructions that the Pulse AI Agent should follow when interacting with customers.",
        "playgroundAssignContent": "Assign knowledge base content to this agent to start testing it in the playground.",
        "playgroundSaveAgentFirst": "Save the agent and assign knowledge base content to start testing it in the playground."
    },
    "InitConversation": {
        "recipient": "Recipient",
        "newConversation": "New conversation",
        "viewConversation": "View conversation",
        "conversationExistsTitle": "Conversation already exists",
        "conversationExistsDescription": "There is an open conversation with this contact via the same location and channel. What would you like to do?",
        "resolveConversation": "Resolve conversation",
        "goToConversation": "Go to conversation"
    },
    "CouponsPage": {
        "title": "Smart coupons to drive loyalty and sales",
        "subtitle": "Create and share special offers to reward happy customers, resolve issues, or boost sales. Customize discounts, free items, and redemption rules across locations.",
        "createNewCoupon": "Create new coupon",
        "createCoupon": "Create coupon",
        "viewCoupon": "View coupon",
        "editCoupon": "Edit coupon",
        "activateCoupon": "Activate coupon",
        "offerType": "Offer type",
        "percentageOff": "Percentage Off",
        "amountOff": "Amount Off",
        "freeItem": "Free item",
        "minimumOrderValue": "Minimum order",
        "offerSchedule": "Offer schedule",
        "offerAndDate": "Offer end date",
        "setFinalIssueDate": "Set the final day this coupon can be used.",
        "redemptionPeriod": "Redemption period",
        "periodOfValidity": "How many days after issuance the coupon stays valid.",
        "redemptionPeriodDays": "Redemption period (days)",
        "waitPeriod": "Wait period",
        "setDelay": "Set the delay before coupon can be redeemed.",
        "waitPeriodHours": "Wait period (hours)",
        "activationPinCode": "Activation PIN code",
        "requireStaffForPin": "Require staff to enter a PIN to confirm redemption",
        "redeemed": "Redeemed {{title}}",
        "defaultMessage": "Default message",
        "issuedCount": "Issued",
        "redeemedCount": "Redeemed"
    },
    "paymentMethod": {
        "cash": "Cash",
        "visa": "Visa",
        "mastercard": "Mastercard",
        "applePay": "Apple Pay",
        "androidPay": "Android Pay",
        "paypal": "PayPal",
        "americanExpress": "American Express",
        "discover": "Discover",
        "invoice": "Invoice",
        "bitcoin": "Bitcoin",
        "travelersCheck": "Traveler's Check",
        "dinersClub": "Diners Club",
        "insurance": "Insurance"
    },
    "Paywall": {
        "whatYouGet": "What you get:",
        "unlockThis": "Unlock this and more with Pluspoint Professional.",
        "titleCoupons": "Coupons that build loyalty and bring customers back",
        "subtitleCoupons": "Reward customers and give them a reason to come back. Use coupons to recover unhappy clients, motivate reviews, and convert engagement into real sales.",
        "proposal1Coupons": "Flexible coupon types including free items and percentage or fixed amount discounts",
        "proposal2Coupons": "Built in analytics to track redemptions, performance, and ROI",
        "proposal3Coupons": "Mobile friendly interactive coupons designed for fast use and high conversion",
        "proposal4Coupons": "No POS integration required, simple to launch and easy to manage",
        "titleCampaigns": "Campaigns that drive repeat business",
        "subtitleCampaigns": "Reach the right customers at the right moment with targeted campaigns across the channels they actually use. Automate recurring messages, launch one-time promotions, and let AI handle replies so conversations keep moving.",
        "proposal1Campaigns": "Automated and one-time campaigns tailored to your goals",
        "proposal2Campaigns": "Smart segmentation based on customer data and behavior",
        "proposal3Campaigns": "Multi-channel outreach via text, email, and WhatsApp",
        "proposal4Campaigns": "AI powered handling of customer responses and conversations",
        "titleSurveys": "Surveys that turn feedback into growth",
        "subtitleSurveys": "Make customer feedback part of your daily operations. Automate feedback collection, resolve complaints early, and generate more reviews from customers who had a great experience.",
        "proposal1Surveys": "Automated surveys sent via messages, email, WhatsApp, and QR codes",
        "proposal2Surveys": "Early detection and resolution of customer complaints",
        "proposal3Surveys": "Review generation from satisfied customers",
        "proposal4Surveys": "Net Promoter Score tracking to measure loyalty and trends over time",
        "titleAutoReplies": "Automated replies you can trust",
        "subtitleAutoReplies": "Respond faster and more consistently to every review without sounding robotic. Let AI reply in a natural, human way while you stay in control of tone, rules, and edge cases.",
        "proposal1AutoReplies": "AI generated replies written to sound natural and personal",
        "proposal2AutoReplies": "Smart logic based on rating and whether a review includes a comment",
        "proposal3AutoReplies": "Custom AI prompts to match your brand voice and policies",
        "proposal4AutoReplies": "Reusable templates for full control and consistency",
        "upgradeForCustomerRating": "Upgrade to collect customer ratings",
        "upgradeForCustomerRatingDescription": "Route happy customers to leave a review and unhappy ones to private feedback.",
        "upgradeForCustomQuestions": "Upgrade to ask custom questions",
        "upgradeForCustomQuestionsDescription": "Add rating, multiple-choice, and open-ended questions to your surveys.",
        "upgradeForSendSurveys": "Upgrade to send surveys",
        "upgradeForSendSurveysDescription": "Send surveys to your contacts via email or SMS, with follow-ups and reminders."
    },
    "GoogleVerification": {
        "title": "Verify Google Business Profile",
        "verifyOnGoogle": "Verify on Google Business",
        "selectMethod": "Select verification method",
        "PHONE_CALL": "Phone call",
        "SMS": "SMS",
        "EMAIL": "Email",
        "ADDRESS": "Postcard (mail)",
        "VETTED_PARTNER": "Verification through a Google partner",
        "AUTO": "Automatic verification",
        "pinSent": "Google sent you a verification code.",
        "pinSentTo": "A verification code was sent to",
        "pinPlaceholder": "Verification code",
        "postcardMailed": "Google mailed a postcard to your business address.",
        "postcardMailedOn": "Google mailed a postcard to your business address on {{date}}.",
        "postcardArrives": "It should arrive in about {{days}} days.",
        "postcardComeBack": "Come back and enter the code when it arrives.",
        "postcardTo": "The postcard goes to",
        "checkInProgress": "Google is checking this profile. The profile updates when it finishes.",
        "lastAttemptFailed": "Your last attempt ({{method}}) did not complete.",
        "lastAttemptFailedOn": "Your last attempt ({{method}}), requested on {{date}}, did not complete.",
        "pinSentOn": "A verification code was sent on {{date}}.",
        "pendingStillOpen": "A {{method}} verification is still open. Choosing another method starts a new one.",
        "pendingStillOpenOn": "A {{method}} verification requested on {{date}} is still open. Choosing another method starts a new one.",
        "latestLookupFailed": "We could not check whether a verification is already in progress, so starting one may duplicate it.",
        "verificationComplete": "Profile verified. The listing updates in a moment.",
        "verificationFailed": "That verification did not complete. Try again or choose another method.",
        "mailboxName": "Mailbox name",
        "resendPostcard": "Mail a new postcard",
        "useAnotherMethod": "Use a different method"
    },
    "exports": {
        "exporting": "Exporting data...",
        "ready": "Export ready",
        "failed": "Export failed"
    },
    "importLoading": {
        "connectingGoogle": "Connecting to your Google account...",
        "fetchingDetails": "Fetching location details...",
        "settingUp": "Setting up your locations...",
        "almostDone": "Almost done, just a moment...",
        "progress": "Imported {{current}} of {{total}} locations"
    },
    "MenusPage": {
        "title": "One place for all your location menus",
        "subtitle": "Build and update your menus in one place, then publish them to your microsites and Google Business Profile. Keep dishes, prices, and photos fresh across all your locations.",
        "createMenu": "Create menu",
        "importWithAi": "Import with AI",
        "importButton": "Import",
        "importModalDescription": "Upload your existing menu — a PDF, photos, a spreadsheet, or a document — and AI will turn it into a menu draft you can review and edit.",
        "importDropFiles": "Drop files here or click to browse",
        "importTooManyFiles": "You can upload up to {{count}} files",
        "importReadingFiles": "Reading your files...",
        "importExtractingItems": "Extracting sections and items...",
        "importFetchingImages": "Importing item photos...",
        "importAlmostDone": "Almost done, just a moment...",
        "editMenu": "Edit menu",
        "modalTitle": "Menu",
        "builder": "Menu builder",
        "internalName": "Internal name",
        "internalNameHint": "Only visible to your team",
        "cuisines": "Cuisines",
        "locations": "Locations",
        "menuLocalization": "Menu name and description",
        "duplicate": "Duplicate",
        "sections": "Sections",
        "addSection": "Add section",
        "itemsCount": "items",
        "items": "Items",
        "publishedOnGoogle": "Published on Google",
        "untitledSection": "Untitled section",
        "addItem": "Add item",
        "item": "Item",
        "untitledItem": "Untitled item",
        "itemName": "Item name",
        "itemPhoto": "Item photo",
        "itemPhotoFormat": "Format: JPG or PNG. Size: up to 10MB.",
        "price": "Price",
        "additionalAttributes": "Additional attributes",
        "addItemOptions": "Add item options",
        "option": "Option",
        "untitledMenu": "Menu",
        "previewEmpty": "Add sections and items to see the menu preview.",
        "spiciness": "Spiciness",
        "allergens": "Allergens",
        "dietaryRestrictions": "Dietary restrictions",
        "preparationMethods": "Preparation methods",
        "ingredients": "Ingredients",
        "portionQuantity": "Portion quantity",
        "portionUnit": "Portion unit (e.g. pieces, oz)",
        "servesNumPeople": "Serves (number of people)",
        "calories": "Calories",
        "nutrition": {
            "totalFat": "Total fat",
            "cholesterol": "Cholesterol",
            "sodium": "Sodium",
            "totalCarbohydrate": "Total carbohydrate",
            "protein": "Protein"
        },
        "units": {
            "GRAM": "g",
            "MILLIGRAM": "mg"
        },
        "cuisineValues": {
            "AMERICAN": "American",
            "ASIAN": "Asian",
            "BRAZILIAN": "Brazilian",
            "BREAK_FAST": "Breakfast",
            "BRUNCH": "Brunch",
            "CHICKEN": "Chicken",
            "CHINESE": "Chinese",
            "FAMILY": "Family",
            "FAST_FOOD": "Fast food",
            "FRENCH": "French",
            "GREEK": "Greek",
            "GERMAN": "German",
            "HAMBURGER": "Hamburger",
            "INDIAN": "Indian",
            "INDONESIAN": "Indonesian",
            "ITALIAN": "Italian",
            "JAPANESE": "Japanese",
            "KOREAN": "Korean",
            "LATIN_AMERICAN": "Latin American",
            "MEDITERRANEAN": "Mediterranean",
            "MEXICAN": "Mexican",
            "PAKISTANI": "Pakistani",
            "PIZZA": "Pizza",
            "SEAFOOD": "Seafood",
            "SPANISH": "Spanish",
            "SUSHI": "Sushi",
            "THAI": "Thai",
            "TURKISH": "Turkish",
            "VEGETARIAN": "Vegetarian",
            "VIETNAMESE": "Vietnamese",
            "OTHER_CUISINE": "Other"
        },
        "spicinessValues": {
            "MILD": "Mild",
            "MEDIUM": "Medium",
            "HOT": "Hot"
        },
        "allergenValues": {
            "DAIRY": "Dairy",
            "EGG": "Egg",
            "FISH": "Fish",
            "PEANUT": "Peanut",
            "SHELLFISH": "Shellfish",
            "SOY": "Soy",
            "TREE_NUT": "Tree nut",
            "WHEAT": "Wheat"
        },
        "dietaryValues": {
            "HALAL": "Halal",
            "KOSHER": "Kosher",
            "ORGANIC": "Organic",
            "VEGAN": "Vegan",
            "VEGETARIAN": "Vegetarian"
        },
        "preparationValues": {
            "BAKED": "Baked",
            "BARBECUED": "Barbecued",
            "BASTED": "Basted",
            "BLANCHED": "Blanched",
            "BOILED": "Boiled",
            "BRAISED": "Braised",
            "CODDLED": "Coddled",
            "FERMENTED": "Fermented",
            "FRIED": "Fried",
            "GRILLED": "Grilled",
            "KNEADED": "Kneaded",
            "MARINATED": "Marinated",
            "PAN_FRIED": "Pan-fried",
            "PICKLED": "Pickled",
            "PRESSURE_COOKED": "Pressure-cooked",
            "ROASTED": "Roasted",
            "SAUTEED": "Sautéed",
            "SEARED": "Seared",
            "SIMMERED": "Simmered",
            "SMOKED": "Smoked",
            "STEAMED": "Steamed",
            "STEEPED": "Steeped",
            "STIR_FRIED": "Stir-fried",
            "OTHER_METHOD": "Other"
        },
        "issuesTitle": "Complete the following to save the menu:",
        "issueInternalName": "Add an internal name",
        "issueName": "Add a title",
        "issueNameLength": "Keep the title under 140 characters",
        "issueDescriptionLength": "Keep the description under 1000 characters",
        "issueIngredientsLength": "Keep each ingredients list under 5000 characters",
        "issueCurrency": "Select a currency",
        "issueLocations": "Assign at least one location",
        "issueSections": "Add at least one section",
        "issueSectionNames": "Name every section",
        "issueSectionItems": "Every section needs at least one item",
        "issueItemNames": "Name every item",
        "issueItemPrices": "Set a price for every item",
        "issueOptionNames": "Name every option",
        "showOnGoogle": "Show on Google Business Profile",
        "showOnGoogleHint": "While enabled, this menu is live on Google Business Profile for connected restaurant locations. Turning it off removes the menu from Google.",
        "google": "Google",
        "titleOptional": "Title (optional)",
        "noItems": "No items in this section yet",
        "editSection": "Edit section"
    },
    "SubscribeLock": {
        "freemiumRetiredTitle": "The free plan has been retired",
        "freemiumRetiredSubtitle": "Your reviews, contacts and conversations are safe — subscribe to pick up right where you left off.",
        "trialEndedTitle": "Your free trial has ended",
        "trialEndedSubtitle": "Keep everything you set up during the trial — subscribe to continue.",
        "askAccountOwner": "Not an admin? Ask your account owner to upgrade.",
        "directoriesIntentTitle": "Subscribe to add Local Directories",
        "directoriesIntentSubtitle": "Local Directories requires an active subscription — subscribe and add {{location}} in one step."
    },
    "TemplateLibrary": {
        "title": "Template library",
        "subtitle": "Ready-made designs for your campaigns. Build an email or WhatsApp template once, keep it on brand, and reuse it every time you launch a campaign.",
        "filterChannelType": "Channel type",
        "filterBrands": "Brands",
        "tabSettings": "Settings",
        "tabContent": "Content",
        "tabPreview": "Preview",
        "backToBlocks": "Back to blocks",
        "paletteHint": "Click a block or drag it into your email",
        "dropHint": "Drag a block here",
        "emptyState": "No templates yet. Create your first template to get started.",
        "channelEmail": "Email",
        "systemTemplate": "Example",
        "archived": "Archived",
        "usedByCampaigns": "{{count}} campaign or automation",
        "usedByCampaigns_plural": "{{count}} campaigns or automations",
        "duplicate": "Duplicate",
        "archive": "Archive",
        "unarchive": "Unarchive",
        "duplicated": "Template duplicated",
        "deleteDescription": "Delete template \"{{name}}\"? This cannot be undone.",
        "deleteBlocked": "This template is used by campaigns or automations and cannot be deleted. Archive it instead.",
        "createTemplateTitle": "New email template",
        "editTemplateTitle": "Edit email template",
        "viewTemplateTitle": "Email template",
        "saveTemplate": "Save template",
        "sendTest": "Send test",
        "sendTestHint": "Send yourself a test to see exactly what your contacts will receive.",
        "templateName": "Template name",
        "preheader": "Preheader",
        "deviceDesktop": "Desktop",
        "deviceMobile": "Mobile",
        "emailChannel": "Email channel",
        "testSendSuccess": "Test email sent",
        "testSendFail": "Failed to send the test email",
        "loadingPreview": "Rendering preview…",
        "blocks": "Blocks",
        "textColor": "Text color",
        "buttonColor": "Button color",
        "buttonShape": "Button shape",
        "shape_square": "Square",
        "shape_rounded": "Rounded",
        "shape_pill": "Pill",
        "blockLogo": "Logo",
        "blockImage": "Image",
        "blockHeading": "Heading",
        "blockText": "Text",
        "blockButton": "Button",
        "blockDivider": "Divider",
        "blockSpacer": "Spacer",
        "blockColumns": "Columns",
        "columnsHint": "Drag blocks from the palette into either column, or click an element inside a column to edit it.",
        "cornerRadius": "Corner radius",
        "blockSocial": "Social links",
        "logoPlaceholder": "Logo",
        "imagePlaceholder": "Select the block to upload an image",
        "headingPlaceholder": "Heading",
        "textPlaceholder": "Write your text…",
        "buttonPlaceholder": "Button",
        "socialPlaceholder": "Social links — from the location profile",
        "headingText": "Heading text",
        "textContent": "Text",
        "imageAlt": "Alt text",
        "buttonLabel": "Button name",
        "buttonDestination": "Destination",
        "bindingUrl": "Custom URL",
        "bindingSurvey": "Survey link",
        "bindingCoupon": "Coupon link",
        "spacerHeight": "Height (px)",
        "logoHint": "The logo resolves from your brand or location branding when the email is sent.",
        "socialHint": "Facebook and Instagram links come from the location profile.",
        "padding": "Padding",
        "headingLevel": "Heading level",
        "fontSize": "Text size",
        "buttonSize": "Button size",
        "buttonWidth": "Button width",
        "widthFull": "Full width",
        "widthAuto": "Fit content",
        "imageWidth": "Image width",
        "lineColor": "Line color",
        "thickness": "Thickness",
        "footerPreviewInfo": "Company name · Business address",
        "footerPreviewLinks": "Unsubscribe · Privacy policy",
        "footerLockedTooltip": "Added automatically to every email with your real business details",
        "alignment": "Alignment",
        "alignLeft": "Left",
        "alignCenter": "Center",
        "alignRight": "Right",
        "emailDesign": "Email design",
        "createNew": "Create new",
        "surveyLinkHint": "Filled with the survey link by the campaign that uses this template.",
        "couponLinkHint": "Filled with the coupon link by the campaign that uses this template.",
        "noBrand": "No brand",
        "dynamicLinkRequired": "Survey and coupon campaigns need a template with a dynamic link button.",
        "dynamicLinkNotSupported": "Templates with a dynamic link button can only be used in survey or coupon campaigns.",
        "channelWhatsApp": "WhatsApp",
        "newEmailTemplate": "Create email template",
        "newWhatsAppTemplate": "Create WhatsApp template",
        "waChannelRequired": "Connect a WhatsApp Business channel to create WhatsApp templates.",
        "waStatus_draft": "Draft",
        "waStatus_pending": "In review",
        "waStatus_approved": "Approved",
        "waStatus_rejected": "Rejected",
        "waStatus_paused": "Paused",
        "waStatus_disabled": "Disabled",
        "waNeedsSetup": "Needs setup",
        "waDisconnected": "Disconnected",
        "waEditResubmit": "Edit & resubmit",
        "waCategory": "Category",
        "waCategory_MARKETING": "Marketing",
        "waCategory_UTILITY": "Utility",
        "waWaba": "WhatsApp Business account",
        "waWabaRequired": "Select the WhatsApp Business account for this template.",
        "waNameHint": "Lowercase letters, digits and underscores",
        "waEmptyPreview": "Your message preview will appear here",
        "waNameInvalid": "Use lowercase letters, digits and underscores only.",
        "waHeader": "Header",
        "waHeaderNone": "None",
        "waHeaderText": "Text",
        "waHeaderImage": "Image",
        "waHeaderTextLabel": "Header text",
        "waHeaderOneVariable": "A text header allows at most one variable.",
        "waHeaderImageRequired": "Upload a header image or switch the header to none.",
        "waBody": "Body",
        "waBodyEdgeVariable": "The message body cannot start or end with a variable.",
        "waBodyMixedVariables": "Don't mix named and numbered variables in one template.",
        "waFooter": "Footer",
        "waFooterLabel": "Footer text (optional)",
        "waButtons": "Buttons",
        "waAddButton": "Add button",
        "waButtonQuickReply": "Quick reply",
        "waButtonUrl": "URL",
        "waButtonPhone": "Phone",
        "waButtonWebsite": "Visit website",
        "waButtonSurvey": "Survey link",
        "waButtonCoupon": "Coupon link",
        "waUrlAbsolute": "Button URLs must start with http:// or https://.",
        "waLinkTypeCouponOnly": "This template's link button targets coupon links, so it can only serve coupon campaigns.",
        "waLinkTypeSurveyOnly": "This template's link button targets survey links, so it cannot serve coupon campaigns.",
        "waQuickRepliesGrouped": "Quick-reply buttons must be grouped together.",
        "waButtonsIncomplete": "Fill in every button's label and destination.",
        "waVariables": "Variables",
        "waResolution": "Filled with",
        "waGroupContact": "Contact",
        "waGroupLocation": "Location",
        "waMappingRequired": "Choose how each variable is filled.",
        "waViewTemplateTitle": "WhatsApp template",
        "waEditTemplateTitle": "Edit WhatsApp template",
        "waCreateTemplateTitle": "New WhatsApp template",
        "waSaveDraft": "Save draft",
        "waSubmitForReview": "Submit for review",
        "waSubmitted": "Template submitted for review",
        "waReviewNote": "Meta reviews templates after submission — usually within a few hours, up to 24h.",
        "waPendingBanner": "This template is in review by Meta and is read-only until the review finishes.",
        "waDisabledBanner": "Meta disabled this template. It cannot be edited or used in campaigns.",
        "waRejectedBanner": "Meta rejected this template. Fix the content and resubmit.",
        "waResubmitBanner": "Saving sends the template back to Meta for review.",
        "noLinkButton": "This template has no dynamic link button, so it cannot deliver a survey or coupon link.",
        "linkButtonNotSupported": "This template has a dynamic link button, so it can only be used by survey or coupon campaigns.",
        "waLockedByCampaigns": "This template is used by scheduled or running campaigns or active automations. Duplicate it to edit, or remove those references first.",
        "waMalformedVariable": "Malformed variable — use {{lowercase_name}} with letters, digits and underscores.",
        "waUnknownVariable": "Unknown variable — use one of the available fields.",
        "waFromContact": "from contact",
        "waFromLocation": "from location",
        "waLinkSlotInfo": "The URL button is filled with the survey or coupon link."
    },
    "ImpersonationBanner": {
        "impersonatedBy": "Impersonated by {{name}} from Pluspoint",
        "impersonatedByPartner": "Impersonated by {{name}}",
        "minutesLeft": "{{count}} min left",
        "exit": "Exit"
    }
}
